import React, { useCallback, useMemo, useState } from 'react';
import { FC } from 'react';
import { useReport } from 'reports/pages/AddNewReport/AddNewReport';
import { Grid } from '@material-ui/core';
import IconCard from 'app/components/IconCard';
import styles from './AnalyedInfluencerCharts.module.scss';
import { _t } from 'app/utils/i18n';
import {
  BigHeartIcon,
  CalenderIcon,
  CelebrateIcon,
  ClockIcon,
  EmployeeIcon,
  EyeIcon,
  EyeTimeIcon,
  FollowerIcon,
  FollowingIcon,
  ImpressionIcon,
  InfTwitter,
  InsightfulIcon,
  LanguageIcon,
  LastTweetClientIcon,
  LastTweetPerDayIcon,
  LikeIcon,
  NewsArticle,
  NewsTotalSources,
  OpenJobsIcon,
  RecentActivityTime,
  SubscribersIcon,
  SupportIcon,
  InstaComment,
  TimeFrameIcon,
  TopicsIcon,
  TweetsInterval,
  UploadVideoIcon,
  UserNetworkIcon,
  RetweetTweetIcon,
  TweetRepliesIcon,
  TweetQuotesIcon,
  BookmarkBigIcon,
  TweetClient,
  TweetType,
} from 'app/assets/images/icons';
import {
  entitiesApiRoutes,
  influencerApiRoutes,
} from 'influencers/utils/apiRoutes';
import BaseLine from 'app/components/Charts/BaseLine';
import SecondaryTable from 'app/components/Tables/SecondaryTable';
import FullCalendarBlock from 'influencers/components/FullCalendarBlock';
import { checkHoveringTranslated, checkTranslated } from 'app/utils/helpers';
import { nFormatter } from 'app/utils/numbersFormater';
import ToolTipComp from 'app/components/ToolTipComp';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { path } from 'app/utils/path';
import { useQuery, useQueryClient } from 'react-query';
import { useModal } from 'app/context/Modal';
import AddComment from 'reports/components/AddComment';
import DonutChart from 'app/components/Charts/DonutChart';
import RecentMedia from '../RecentMedia';
import { getFromLocalStorage } from 'app/utils/localStorage';
import { savePrevSearchState } from 'app/utils/search-state';
import { extractTitleOrSubTileOrReportNameOrDesc } from 'reports/utils/utils';
import TwitterFollowersTab from '../TwitterTabContent/TwitterFollowersTab';
import TwitterFollowingTab from '../TwitterTabContent/TwitterFollowingTab';
import PrimaryMainTable from 'app/components/Tables/PrimaryMainTable';
import CardTitle from 'app/components/CardTitle';
import { getInfluencerRelatedInfluencers } from 'influencers/pages/RelatedInfluencers/Tables/InfluencerRelatedInfluencers';
import { getInfluencerRelatedEntities } from 'influencers/pages/RelatedInfluencers/Tables/InfluencerRelatedEntities';
import { getEntityRelatedInfluencers } from 'influencers/pages/RelatedInfluencers/Tables/EntityRelatedInfluencers';
import { getEntityRelatedEntities } from 'influencers/pages/RelatedInfluencers/Tables/EntityRelatedEntities';
import { isValidHttpUrl } from 'app/utils/stringMethods';
import { apiRoutes } from 'tweets/utils/apiRoutes';
import MostFrequentCard from 'app/components/MostFrequentCard';
import ErrorBoundary from 'app/components/ErrorBoundary';
import { dateTimeFormatter } from 'app/utils/dateTimeFormatter';
import TweetBox from 'app/components/TweetBox';
import { loadConversationReplies } from 'tweets/Requests';
import { jobsColumns } from '../LinkedinTabContent/LinkedinJobTab/LinkedinJobTab';
import { headerCell } from 'trends/components/TrendsCustmComps/TrendsCustmComps';
import AvatarCell from 'app/components/Tables/Cells/AvatarCell';
import { dateFormatter } from 'app/utils/datePickerFormatter';
import TwitterTweetCard from 'app/components/TwitterTweetCard';
const isEn = getFromLocalStorage('LNG') === 'en';

interface IAnalyedInfluencerCharts {
  influencer_id: any;
  isReport?: boolean;
  isTemplate?: boolean;
  isInfluencerModule?: boolean;
  setActiveTab?: any;
  setOpenTab?: any;
  setlikesEngagementFilter?: any;
  openModalToAddinfluencer?: any;
  setInfluencerName?: any;
  youtubeData?: any;
  twitterData?: any;
  tweetData?: any;
  instagramData?: any;
  tab?: string;
  removeComments?: boolean;
  handelAnalyzedCalender?: any;
  InfluencerStatus?: string;
  items?: any[];
  twitter_profile_id?: number;
  instagram_profile_id?: number;
  channel_id?: number;
  linkedInData?: any;
  linkedin_profile_id?: number;
  is_full_grabbed?: boolean;
  tweet_id?: number;
  isEntity?: boolean;
}

export const checkDay = (days: any) => {
  if (days === 1) {
    return _t('influencers:day_ago');
  } else if (days === 0) {
    return '-';
  } else if (days === 2) {
    return _t('influencers:two_day_ago');
  } else {
    return isEn
      ? `${days} ${_t('influencers:days_ago')}`
      : `${_t('influencers:ago')} ${days} ${
          days > 10 ? _t('influencers:day') : _t('influencers:days')
        }`;
  }
};

const AnalyedInfluencerCharts: FC<IAnalyedInfluencerCharts> = ({
  influencer_id,
  isReport,
  setActiveTab,
  setOpenTab,
  isTemplate,
  isInfluencerModule,
  openModalToAddinfluencer,
  setInfluencerName,
  tab,
  setlikesEngagementFilter,
  youtubeData,
  twitterData,
  removeComments,
  handelAnalyzedCalender,
  InfluencerStatus,
  items,
  twitter_profile_id,
  channel_id,
  linkedInData,
  linkedin_profile_id,
  is_full_grabbed,
  instagramData,
  instagram_profile_id,
  tweetData,
  tweet_id,
  isEntity,
}) => {
  const report = useReport() as any;
  const isInDownloadCharts = location.pathname.includes('download');
  const queryClient = useQueryClient();
  const { pathname } = useLocation();
  const history = useHistory();
  const [addRepliesConvChartToReport, setAddRepliesConvChartToReport] =
    useState(false);
  const modal = useModal();
  const modules: string[] =
    queryClient.getQueryData('getAuthorizedModules') || [];
  const influencerDetails = queryClient.getQueryData<any>('influencerDetails');
  const isAr = getFromLocalStorage('LNG') === 'ar';
  const handelAuthorizationVideos = (data: any) => {
    modules.includes('POSTS')
      ? history.push(`${path.posts.YOUTUBE_POST_DETAILS_URI}/${data.video_id}`)
      : modal.show({
          isAlternative: true,
          message: _t('basic:you_are_not_authorize'),
        });
  };
  const { data: conversationReplies, isLoading: conversationRepliesLoad } =
    useQuery({
      queryKey: ['repliesConv'],
      queryFn: () =>
        loadConversationReplies({ id: tweetData?.id, is_sample: isTemplate }),
      enabled: !!isReport && !isInfluencerModule && !isEntity,
      onSuccess: () => setAddRepliesConvChartToReport(true),
    });

  const infDetails = [
    {
      title: _t('tweets:inf_ent_name'),
      key: 'name',
    },
    {
      title: _t('videos:joined'),
      key: 'joined_at',
    },
    {
      title: _t('tweets:followers'),
      key: 'followers_count',
    },
    {
      title: _t('tweets:location'),
      key: 'location',
    },
  ];

  const tweetsChartSlug = useMemo(
    () =>
      isInfluencerModule
        ? influencerApiRoutes().twitterAnalyzedTweets
        : entitiesApiRoutes().twitterAnalyzedTweets,
    [isInfluencerModule],
  );
  const handelHashtagAuthorization = (data: any) => {
    modules.includes('HASHTAGS')
      ? history.push(
          `${path.hashtags.HASHTAG_VIEW_URI}/${
            data.hashtag_id || data.id
          }/${savePrevSearchState(
            checkTranslated(
              data?.hashtag_name?.original || data?.label?.original,
              data?.hashtag_name?.arabic || data?.label?.arabic,
            ),
          )}`,
        )
      : modal.show({
          isAlternative: true,
          message: _t(`basic:you_are_not_authorize`),
        });
  };
  const relatedChannelsColumns = [
    {
      title: _t('basic:channel'),
      key: 'name',
      render: (val: any, row: any) => {
        const influencerId = row?.influencer?.influencer_id;
        const is_entity = row?.influencer?.is_entity;
        const is_influencer = row?.influencer?.is_influencer;
        const username = row?.name;
        const remote_id = row?.remote_id;

        return influencerId !== 0 ? (
          <Link
            to={`${
              is_entity
                ? path.entities.ANALYZED_ENTITIES_DETAILS_URI
                : is_influencer
                  ? path.influencers.ANALYZED_INFLUENCER_DETAILS_URI
                  : path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI
            }/${influencerId}`}
          >
            {typeof row?.name === 'string' ? (
              <ToolTipComp title={row?.name}>
                <div>
                  {row?.name?.length > 17
                    ? `${row?.name?.substring(0, 17)}...`
                    : row?.name}
                </div>
              </ToolTipComp>
            ) : (
              <ToolTipComp>
                <div>
                  {checkTranslated(val?.original, val?.arabic)?.length > 17
                    ? `${checkTranslated(val?.original, val?.arabic)?.substring(
                        0,
                        17,
                      )} ....`
                    : checkTranslated(val?.original, val?.arabic)}
                </div>
              </ToolTipComp>
            )}
          </Link>
        ) : (
          <div
            onClick={() => {
              openModalToAddinfluencer(remote_id, row?.url);
              setInfluencerName(username);
            }}
            className="cursor-pointer"
          >
            {typeof row?.name === 'string' ? (
              <ToolTipComp title={row?.name}>
                <div>
                  {row?.name?.length > 17
                    ? `${row?.name?.substring(0, 17)}...`
                    : row?.name}
                </div>
              </ToolTipComp>
            ) : (
              <ToolTipComp title={checkTranslated(val?.original, val?.arabic)}>
                <div>
                  {checkTranslated(val?.original, val?.arabic)?.length > 17
                    ? `${checkTranslated(val?.original, val?.arabic)?.substring(
                        0,
                        17,
                      )} ................`
                    : checkTranslated(val?.original, val?.arabic)}
                </div>
              </ToolTipComp>
            )}
          </div>
        );
      },
    },
    {
      title: _t('basic:subscribers_count'),
      key: 'subscribers_count',
      render: (value: number) => (
        <p style={{ display: 'flex ', justifyContent: 'center' }}>
          {nFormatter(value)}
        </p>
      ),
    },
    {
      title: 'basic:translation',
      key: 'hashtag_name',
      render: (val: any, row: any) => (
        <>
          {row?.name?.arabic?.length > 0 ? (
            <ToolTipComp
              title={checkTranslated(row?.name?.original, row?.name?.arabic)}
            >
              <LanguageIcon />
            </ToolTipComp>
          ) : (
            <p> - </p>
          )}
        </>
      ),
    },
  ];

  const topVideosColumns = [
    {
      title: _t('basic:video'),
      key: 'label',
      render: (val: any, row: any) => (
        <a
          onClick={() => handelAuthorizationVideos(row)}
          className="cursor-pointer"
          title={checkTranslated(val?.original, val?.arabic)}
        >
          {checkTranslated(val?.original, val?.arabic)?.length > 20
            ? `${checkTranslated(val?.original, val?.arabic)?.slice(0, 20)} ...`
            : checkTranslated(val?.original, val?.arabic)}
        </a>
      ),
    },
    {
      title: _t('basic:views'),
      key: 'value',
      render: (value: number) => <p> {nFormatter(value)}</p>,
    },
    {
      title: 'basic:translation',
      key: 'label',
      render: (val: any, row: any) => (
        <>
          {row?.label?.arabic?.length > 0 ? (
            <ToolTipComp
              title={checkHoveringTranslated(
                row?.label?.original,
                row?.label?.arabic,
              )}
            >
              <LanguageIcon />
            </ToolTipComp>
          ) : (
            <p> - </p>
          )}
        </>
      ),
    },
  ];

  const recentPostsColumns = [
    {
      title: _t('influencers:post'),
      key: 'post',
      render: (val: any) => (
        <p
          style={isValidHttpUrl(val?.original) ? { textTransform: 'none' } : {}}
        >
          {checkTranslated(val?.original, val.arabic)}
        </p>
      ),
    },
    {
      title: _t('videos:engagement'),
      key: 'engagements',
      render: (value: number) => <p> {nFormatter(value)}</p>,
    },
  ];

  const topPeopleConversation = [
    {
      title: _t('basic:username'),
      key: 'username',
      render: (value: number, row: any) =>
        row?.influencer?.influencer_id === influencerDetails?.influencer_id ? (
          <></>
        ) : row?.influencer?.influencer_id != 0 ||
          (row?.user_id != 0 && !isInfluencerModule) ? (
          <Link
            to={`${
              row?.influencer?.is_entity
                ? path.entities.ANALYZED_ENTITIES_DETAILS_URI
                : row?.influencer?.is_influencer || row?.user_id
                  ? path.influencers.ANALYZED_INFLUENCER_DETAILS_URI
                  : path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI
            }/${row?.influencer?.influencer_id || row?.user_id}`}
          >
            {row?.influencer?.name?.original
              ? row?.influencer?.name?.original
              : row?.username}
          </Link>
        ) : (
          <p
            onClick={() => {
              openModalToAddinfluencer(
                typeof row?.username === 'string'
                  ? row?.username
                  : row?.username?.original,
                row?.influencer?.url,
              );
              setInfluencerName(
                typeof row?.username === 'string'
                  ? row?.username
                  : row?.username?.original,
              );
            }}
            className="cursor-pointer"
          >
            {typeof row?.username === 'string'
              ? row?.username
              : row?.username?.original}
          </p>
        ),
    },
    {
      title:
        tab == 'linkedin'
          ? _t('influencers:Number_of_comments')
          : _t('influencers:Number_of_conversations'),

      key: tab == 'linkedin' ? 'comments_count' : 'tweets_count',
      render: (value: number, row: any) =>
        tab == 'linkedin' ? (
          (row?.influencer?.influencer_id !==
            influencerDetails?.influencer_id ||
            !isReport) && <p>{nFormatter(row?.comments_count)}</p>
        ) : (
          <p>{nFormatter(row?.comments_count || row?.tweets_count)}</p>
        ),
    },
  ];

  const topGeoLocations = [
    {
      title: _t('hashtags:location'),
      key: 'location',
      render: (value: number, row: any) => (
        <p title={row?.location}>{row?.location}</p>
      ),
    },
    {
      title: _t('influencers:tweets'),
      key: 'count',
      render: (value: number, row: any) => (
        <p>{row?.count > 0 ? nFormatter(row?.count) : '_'}</p>
      ),
    },
  ];
  const frequentHashtags = [
    {
      title: _t('trends:hashtag'),
      key: 'hashtag_name',
      render: (val: any, row: any) => (
        <a
          onClick={() => handelHashtagAuthorization(row)}
          className="cursor-pointer"
        >
          {checkTranslated(
            row?.hashtag_name?.original,
            row?.hashtag_name?.arabic,
          )}
        </a>
      ),
    },
    {
      title: _t('trends:mentions'),
      key: 'hashtag_count',
      render: (value: number) => <p>{nFormatter(value)}</p>,
    },
    {
      title: 'basic:translation',
      key: 'title',
      render: (val: any, row: any) => (
        <>
          {row?.hashtag_name?.arabic?.length > 0 ? (
            <ToolTipComp
              title={checkHoveringTranslated(
                row?.hashtag_name?.original,
                row?.hashtag_name?.arabic,
              )}
            >
              <LanguageIcon />
            </ToolTipComp>
          ) : (
            <p> -</p>
          )}
        </>
      ),
    },
  ];
  const youtubeFrequentHashtags = [
    {
      title: _t('trends:hashtag'),
      key: 'label',
      render: (val: any, row: any) => (
        <a
          onClick={() => handelHashtagAuthorization(row)}
          className="cursor-pointer"
        >
          {checkTranslated(row?.label?.original, row?.label?.arabic)}
        </a>
      ),
    },
    {
      title: _t('trends:mentions'),
      key: 'value',
      render: (value: number) => <p>{nFormatter(value)}</p>,
    },
    {
      title: 'basic:translation',
      key: 'title',
      render: (val: any, row: any) => (
        <>
          {row?.label?.arabic?.length > 0 ? (
            <ToolTipComp
              title={checkHoveringTranslated(
                row?.label?.original,
                row?.label?.arabic,
              )}
            >
              <LanguageIcon />
            </ToolTipComp>
          ) : (
            <p> -</p>
          )}
        </>
      ),
    },
  ];
  const instaFrequentHashtags = [
    {
      title: _t('trends:hashtag'),
      key: 'hashtag_name',
      render: (val: any, row: any) => (
        <a
          onClick={() => handelHashtagAuthorization(row)}
          className="cursor-pointer"
        >
          {checkTranslated(
            row?.hashtag_name?.original,
            row?.hashtag_name?.arabic,
          )}
        </a>
      ),
    },
    {
      title: _t('influencers:posts'),
      key: 'hashtag_count',
      render: (value: number) => <p>{nFormatter(value)}</p>,
    },
  ];
  const topWords = [
    {
      title: _t('basic:word'),
      key: 'word_name',
      render: (val: any, row: any) => (
        <div>
          {checkTranslated(row?.word_name?.original, row?.word_name?.arabic)}
        </div>
      ),
    },
    {
      title: _t('basic:usage'),
      key: 'word_count',
      render: (value: number) => <p>{nFormatter(value)}</p>,
    },
  ];
  const topYoutubeTags = [
    {
      title: _t('basic:tag'),
      key: 'label',
      render: (val: any, row: any) => (
        <div>{checkTranslated(row?.label?.original, row?.label?.arabic)}</div>
      ),
    },
    {
      title: _t('trends:mentions'),
      key: 'value',
      render: (value: number) => <p>{nFormatter(value)}</p>,
    },
    {
      title: 'basic:translation',
      key: 'title',
      render: (val: any, row: any) => (
        <>
          {row?.label?.arabic?.length > 0 ? (
            <ToolTipComp
              title={checkHoveringTranslated(
                row?.label?.original,
                row?.label?.arabic,
              )}
            >
              <LanguageIcon />
            </ToolTipComp>
          ) : (
            <p> -</p>
          )}
        </>
      ),
    },
  ];

  const instaTopWords = [
    {
      title: _t('basic:word'),
      key: 'word_name',
      render: (val: any, row: any) => (
        <div>
          {checkTranslated(row?.word_name?.original, row?.word_name?.arabic)}
        </div>
      ),
    },
    {
      title: _t('influencers:posts'),
      key: 'word_count',
      render: (value: number) => <p>{nFormatter(value)}</p>,
    },
  ];
  const instaTopTagged = [
    {
      title: _t('basic:username'),
      key: 'user_name',
      render: (val: any, row: any) => {
        return (
          <div>
            {row?.influencer?.influencer_id === 0 ? (
              <p
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  openModalToAddinfluencer(row?.username, row?.influencer?.url);
                }}
                className="cursor-pointer"
              >
                {row?.username}
              </p>
            ) : (
              <Link
                to={`${
                  row?.influencer?.is_entity
                    ? path.entities.ANALYZED_ENTITIES_DETAILS_URI
                    : row?.influencer?.is_influencer
                      ? path.influencers.ANALYZED_INFLUENCER_DETAILS_URI
                      : path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI
                }/${row?.influencer?.influencer_id}`}
              >
                {row?.influencer?.name?.original
                  ? row?.influencer?.name?.original
                  : row?.username}
              </Link>
            )}
          </div>
        );
      },
    },
    {
      title: _t('basic:tags'),
      key: 'tags_count',
      render: (value: number) => <p>{nFormatter(value)}</p>,
    },
  ];

  const instaTopMentions = [
    {
      title: _t('basic:username'),
      key: 'user_name',
      render: (val: any, row: any) => {
        return (
          <div>
            {row?.influencer?.influencer_id === 0 ? (
              <p
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  openModalToAddinfluencer(row?.username, row?.influencer?.url);
                }}
                className="cursor-pointer"
              >
                {row?.username}
              </p>
            ) : (
              <Link
                to={`${
                  row?.influencer?.is_entity
                    ? path.entities.ANALYZED_ENTITIES_DETAILS_URI
                    : row?.influencer?.is_influencer
                      ? path.influencers.ANALYZED_INFLUENCER_DETAILS_URI
                      : path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI
                }/${row?.influencer?.influencer_id}`}
              >
                {row?.influencer?.name?.original
                  ? row?.influencer?.name?.original
                  : row?.username}
              </Link>
            )}
          </div>
        );
      },
    },
    {
      title: _t('trends:mentions'),
      key: 'mentions_count',
      render: (value: number) => <p>{nFormatter(value)}</p>,
    },
  ];
  const instaSimilarAccounts = [
    {
      title: _t('influencers:account'),
      key: 'word_name',
      render: (val: any, row: any) => {
        return (
          <div>
            {row?.influencer?.influencer_id === 0 ? (
              <p
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  openModalToAddinfluencer(row?.username, row?.influencer?.url);
                }}
                className="cursor-pointer"
              >
                {row?.username}
              </p>
            ) : (
              <Link
                to={`${
                  row?.influencer?.is_entity
                    ? path.entities.ANALYZED_ENTITIES_DETAILS_URI
                    : row?.influencer?.is_influencer
                      ? path.influencers.ANALYZED_INFLUENCER_DETAILS_URI
                      : path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI
                }/${row?.influencer?.influencer_id}`}
              >
                {row?.influencer?.name?.original
                  ? row?.influencer?.name?.original
                  : row?.username}
              </Link>
            )}
          </div>
        );
      },
    },
  ];
  const authorSouceCols = [
    {
      title: _t('news:source_name'),
      key: 'name',
      render: (val: string, data: any) => (
        <Link to={`${path.news.SOURCE_DETAILS_URI}/${data?.id}`}>{val}</Link>
      ),
    },
    {
      title: _t('news:articles'),
      key: 'articles_count',
      render: (value: number) => <p>{nFormatter(value)}</p>,
    },
  ];

  const freqUsesCols = [
    {
      title: _t('news:tags'),
      key: 'tags',
      render: (_: any, data: any) => <div>{data?.name}</div>,
    },
    {
      title: _t('influencers:mentions'),
      key: 'mentions',
      render: (_: any, data: any) => <div>{data?.mentions}</div>,
    },
  ];
  const topMentions = [
    {
      title: _t('basic:username'),
      key: 'username',
      render: (value: number, row: any) =>
        row?.influencer?.influencer_id === influencerDetails?.influencer_id ? (
          <></>
        ) : row?.influencer?.influencer_id != 0 ? (
          <Link
            to={`${
              row?.influencer?.is_entity
                ? path.entities.ANALYZED_ENTITIES_DETAILS_URI
                : row?.influencer?.is_influencer
                  ? path.influencers.ANALYZED_INFLUENCER_DETAILS_URI
                  : path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI
            }/${row?.influencer?.influencer_id}`}
          >
            {row?.influencer?.name?.original}
          </Link>
        ) : (
          <p
            onClick={() => {
              openModalToAddinfluencer(
                typeof row?.username === 'string'
                  ? row?.username
                  : row?.username?.original,
              );
              setInfluencerName(
                typeof row?.username === 'string'
                  ? row?.username
                  : row?.username?.original,
              );
            }}
            className="cursor-pointer"
          >
            {typeof row?.username === 'string'
              ? row?.username
              : row?.username?.original}
          </p>
        ),
    },
    {
      title: _t('influencers:number_of_mentions'),
      key: 'tweets_count',
      render: (value: number) => <p>{nFormatter(value)}</p>,
    },
  ];
  const checkIsReport = useCallback(
    (report: any, notReport: any = undefined) =>
      removeComments ? notReport : isReport && !isTemplate ? report : notReport,
    [isReport, isTemplate, removeComments],
  );
  const addCommentComponent = useCallback(
    (slug: string) =>
      checkIsReport(
        <AddComment {...report} compId={slug} id={influencer_id} />,
      ),
    [checkIsReport, influencer_id, report],
  );

  type TRenderCharts = { id: string; component: JSX.Element }[] | false;
  const checkTime = (value: number, label: string) => {
    if (!label?.length) {
      return '-';
    }
    if (label === 'DAY') {
      if (value === 1) {
        return _t('influencers:day_ago');
      } else if (value === 0) {
        return _t('influencers:less_than_day');
      } else if (value === 2) {
        return _t('influencers:two_day_ago');
      } else {
        return isEn
          ? `${value} ${_t('influencers:days_ago')}`
          : `${_t('influencers:ago')} ${value} ${
              value > 10 ? _t('influencers:day') : _t('influencers:days')
            }`;
      }
    }
    if (label === 'HOUR') {
      if (value === 1) {
        return _t('basic:hour_ago');
      } else if (value === 2) {
        return _t('basic:two_hour_ago');
      } else {
        return isEn
          ? `${value} ${_t('basic:hours_ago')}`
          : `${_t('influencers:ago')} ${value} ${
              value > 10 ? _t('basic:hour') : _t('basic:hours')
            }`;
      }
    }
    if (label === 'MINUTE') {
      if (value === 1) {
        return _t('influencers:minute_ago');
      } else if (value === 2) {
        return _t('influencers:two_minute_ago');
      } else {
        return isEn
          ? `${value} ${_t('influencers:minutes_ago')}`
          : `${_t('influencers:ago')} ${value} ${
              value > 10 ? _t('influencers:minute') : _t('influencers:minutes')
            }`;
      }
    }
  };
  const checkNumberOfDays = (days: any) => {
    if (days === 1) {
      return `${days} ${_t('basic:day')}`;
    } else if (days > 1 && days < 11) {
      return `${days} ${_t('basic:days')}`;
    } else {
      return `${days} ${isEn ? _t('influencers:days') : _t('influencers:day')}`;
    }
  };
  const checkIsTemplate = useMemo(
    () => isTemplate && !isReport,
    [isTemplate, isReport],
  );

  const customTwitterFilters = useMemo(
    () =>
      checkIsTemplate
        ? {
            influencer_id: influencer_id.twitter,
            twitter_profile_id,
            is_sample: true,
          }
        : { influencer_id, twitter_profile_id },
    [influencer_id, checkIsTemplate, twitter_profile_id],
  );
  const customInstagramFilters = useMemo(
    () =>
      checkIsTemplate
        ? {
            influencer_id: influencer_id.instagram,
            instagram_profile_id,
            is_sample: true,
          }
        : { influencer_id, instagram_profile_id },
    [influencer_id, checkIsTemplate, instagram_profile_id],
  );
  const customYoutubeFilters = useMemo(
    () =>
      checkIsTemplate
        ? { influencer_id: influencer_id.youtube, channel_id, is_sample: true }
        : { influencer_id, channel_id },
    [influencer_id, checkIsTemplate, channel_id],
  );
  const customTweetRepliesSentimentFilters = useMemo(
    () => (checkIsTemplate ? { tweet_id, is_sample: true } : { tweet_id }),
    [checkIsTemplate, tweet_id],
  );

  const customAuthorFilters = useMemo(
    () =>
      checkIsTemplate
        ? { influencer_id: influencer_id.author, is_sample: true }
        : { influencer_id },
    [influencer_id, checkIsTemplate],
  );
  const customLinkedInFilters = useMemo(
    () =>
      checkIsTemplate
        ? {
            influencer_id: influencer_id.linkedin,
            linkedin_profile_id,
            is_sample: true,
          }
        : { influencer_id, linkedin_profile_id },
    [influencer_id, linkedin_profile_id, checkIsTemplate],
  );

  const getItemCount = (slug: string) => {
    return items?.find((item) => item?.slug === slug)?.item_count;
  };
  const renderYoutubeCharts: TRenderCharts = [
    {
      id: 'influencers_youtube_analyze_created_date',
      component: (
        <IconCard
          withFilter={!isReport}
          hideInput
          title={
            _t('influencers:created_date') +
            ` ${isReport ? `( ${_t('reports:youtube')} )` : ''}`
          }
          cardData={{
            icon: <CalenderIcon />,
            count: youtubeData?.['joined_at'],
          }}
          hideDay
          compId={'influencers_youtube_analyze_created_date'}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_youtube_analyze_created_date'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_youtube_analyze_channel_subscribers',
      component: (
        <IconCard
          title={
            _t('influencers:channel_subscribers') +
            ` ${isReport ? `( ${_t('reports:youtube')} )` : ''}`
          }
          cardData={{
            icon: <SubscribersIcon />,
            countName: 'subscribe',
          }}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().youtubeAnalyzeTabSubscribers
              : entitiesApiRoutes().youtubeAnalyzeTabSubscribers
          }
          customFilters={customYoutubeFilters}
          withFilter={!isReport}
          compId={'influencers_youtube_analyze_channel_subscribers'}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_youtube_analyze_channel_subscribers'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_youtube_analyze_uploaded_video',
      component: (
        <IconCard
          title={
            _t('influencers:uploaded_video') +
            ` ${isReport ? `( ${_t('reports:youtube')} )` : ''}`
          }
          cardData={{
            icon: <UploadVideoIcon />,
            countName: _t('videos'),
          }}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().youtubeAnalyzeTabUploadedVideos
              : entitiesApiRoutes().youtubeAnalyzeTabUploadedVideos
          }
          customFilters={customYoutubeFilters}
          withFilter={!isReport}
          compId={'influencers_youtube_analyze_uploaded_video'}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_youtube_analyze_uploaded_video'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_youtube_analyze_total_views',
      component: (
        <IconCard
          title={
            _t('influencers:total_views') +
            ` ${isReport ? `( ${_t('reports:youtube')} )` : ''}`
          }
          cardData={{
            icon: <EyeIcon />,
            countName: 'views',
          }}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().youtubeAnalyzeTabTotalViews
              : entitiesApiRoutes().youtubeAnalyzeTabTotalViews
          }
          customFilters={customYoutubeFilters}
          withFilter={!isReport}
          compId={'influencers_youtube_analyze_total_views'}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_youtube_analyze_total_views'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_youtube_analyze_videos',
      component: (
        <Grid item lg={8} sm={12}>
          <BaseLine
            baseLineTitle={
              _t('influencers:videos') +
              ` ${isReport ? `( ${_t('reports:youtube')} )` : ''}`
            }
            // slugName={
            //   isInfluencerModule
            //     ? influencerApiRoutes().youtubeAnalyzeTabVideosChart
            //     : entitiesApiRoutes().youtubeAnalyzeTabVideosChart
            // }
            slugName={influencerApiRoutes().influencerUploadedVideos}
            trendsVideoChannelTooltip
            timeIntervalFilter={!isReport}
            withYearTime={isReport}
            noDayInTimeInterval={!isReport}
            customFilters={{
              channel_ids: [youtubeData?.channel_id],
              channel_id,
              is_sample: checkIsTemplate,
            }}
            hideNames
            compId={'influencers_youtube_analyze_videos'}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_youtube_analyze_videos'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        </Grid>
      ),
    },
    {
      id: 'influencers_youtube_analyze_sentiment',
      component:
        influencerDetails?.status === 'ANALYZED' || isTemplate || isReport ? (
          <DonutChart
            donutTitle={
              _t('trends:sentiment') +
              ` ${isReport ? `( ${_t('reports:youtube')} )` : ''}`
            }
            limit={5}
            showFilter
            hideInput
            customFilters={customYoutubeFilters}
            title={_t('influencers:videos')}
            compId={'influencers_youtube_analyze_sentiment'}
            slug={
              isInfluencerModule
                ? influencerApiRoutes().youtubeAnalyzedTweetSentiment
                : entitiesApiRoutes().youtubeAnalyzedTweetSentiment
            }
            hideIfNoData={!isReport || isInDownloadCharts}
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_youtube_analyze_sentiment'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_youtube_analyze_views_per_day',
      component: (
        <IconCard
          title={
            _t('influencers:views_per_day') +
            ` ${isReport ? `( ${_t('reports:youtube')} )` : ''}`
          }
          cardData={{
            icon: <EyeTimeIcon />,
            count: youtubeData?.['views_per_day_count'],
            countName: 'times',
          }}
          withFilter={!isReport}
          hideInput
          compId={'influencers_youtube_analyze_views_per_day'}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_youtube_analyze_views_per_day'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_youtube_analyze_gained_subscribers',
      component: (
        <Grid item lg={8} sm={12}>
          <BaseLine
            baseLineTitle={
              _t('influencers:gained_subscribers') +
              ` ${isReport ? `( ${_t('reports:youtube')} )` : ''}`
            }
            // slugName={
            //   isInfluencerModule
            //     ? influencerApiRoutes().youtubeAnalyzeTabSubscribersChart
            //     : entitiesApiRoutes().youtubeAnalyzeTabSubscribersChart
            // }
            slugName={influencerApiRoutes().channelSubscribers}
            trendsVideoChannelTooltip
            withMonthlyTime={InfluencerStatus === 'ANALYZED'}
            withYearTime={InfluencerStatus === 'UNANALYZED' || isReport}
            timeIntervalFilter={!isReport}
            customFilters={{
              channel_ids: [youtubeData?.channel_id],
              channel_id,
              is_sample: checkIsTemplate,
            }}
            hideNames
            compId={'influencers_youtube_analyze_gained_subscribers'}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_youtube_analyze_gained_subscribers'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        </Grid>
      ),
    },
    {
      id: 'influencers_youtube_analyze_frequent_used_hashtags',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={
            _t('influencers:frequent_used_hashtags') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          compId={'influencers_youtube_analyze_frequent_used_hashtags'}
          columns={youtubeFrequentHashtags}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().youtubeAnalyzedFrequentHashtags
              : entitiesApiRoutes().youtubeAnalyzedFrequentHashtags
          }
          hideFilters
          customFilters={customYoutubeFilters}
          notPlatforms
          distributed
          hideToggleView
          expandAction={
            isReport
              ? undefined
              : () => {
                  window.scrollTo(0, 0);
                  setActiveTab(1);
                  setOpenTab(3);
                }
          }
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_youtube_analyze_frequent_used_hashtags'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_youtube_analyze_top_words',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={
            _t('influencers:top_words') +
            ` ${isReport ? `( ${_t('reports:youtube')} )` : ''}`
          }
          compId={'influencers_youtube_analyze_top_words'}
          columns={topWords}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().youtubeTabTopWords
              : entitiesApiRoutes().youtubeTabTopWords
          }
          hideFilters
          customFilters={customYoutubeFilters}
          notPlatforms
          distributed
          hideToggleView
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_youtube_analyze_top_words'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_youtube_analyze_top_tags',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={
            _t('influencers:top_tags') +
            ` ${isReport ? `( ${_t('reports:youtube')} )` : ''}`
          }
          compId={'influencers_youtube_analyze_top_tags'}
          columns={topYoutubeTags}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().youtubeTabTopTags
              : entitiesApiRoutes().youtubeTabTopTags
          }
          expandAction={
            isReport
              ? undefined
              : () => {
                  window.scrollTo(0, 0);
                  setActiveTab(1);
                  setOpenTab(4);
                }
          }
          hideFilters
          customFilters={customYoutubeFilters}
          notPlatforms
          distributed
          hideToggleView
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_youtube_analyze_top_tags'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_youtube_analyze_channel_top_videos',
      component: youtubeData?.channel_top_videos.length ? (
        <Grid item lg={5} sm={12}>
          <SecondaryTable
            tableCardTitle={
              _t('influencers:channel_top_videos') +
              ` ${isReport ? `( ${_t('reports:youtube')} )` : ''}`
            }
            compId={'influencers_youtube_analyze_channel_top_videos'}
            columns={topVideosColumns}
            data={youtubeData?.channel_top_videos}
            hideFilters
            expandAction={
              isReport
                ? undefined
                : () => {
                    window.scrollTo(0, 0);
                    setActiveTab(1);
                    setOpenTab(0);
                    setlikesEngagementFilter(true);
                  }
            }
            hideToggleView
            hideIfNoData={!isReport || isInDownloadCharts}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_youtube_analyze_channel_top_videos'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        </Grid>
      ) : (
        <></>
      ),
    },
    {
      id: 'influencers_youtube_analyze_channel_total_views',
      component: (
        <Grid item lg={7} sm={12}>
          <BaseLine
            baseLineTitle={
              _t('influencers:channel_total_views') +
              ` ${isReport ? `( ${_t('reports:youtube')} )` : ''}`
            }
            // slugName={
            //   isInfluencerModule
            //     ? influencerApiRoutes().youtubeAnalyzeTabViewsChart
            //     : entitiesApiRoutes().youtubeAnalyzeTabViewsChart
            // }
            slugName={influencerApiRoutes().channelViews}
            withYearTime={isReport}
            trendsVideoChannelTooltip
            noDayInTimeInterval={!isReport}
            timeIntervalFilter={!isReport}
            customFilters={{
              channel_ids: [youtubeData?.channel_id],
              channel_id,
              is_sample: checkIsTemplate,
            }}
            hideNames
            compId={'influencers_youtube_analyze_channel_total_views'}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_youtube_analyze_channel_total_views'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        </Grid>
      ),
    },
    {
      id: 'influencers_youtube_analyze_videos_calendar',
      component: (
        <Grid item lg={4} sm={12}>
          <FullCalendarBlock
            isInfluencerModule={isInfluencerModule}
            compId={'influencers_youtube_analyze_videos_calendar'}
            id={checkIsTemplate ? influencer_id.youtube : influencer_id}
            slug={'details/youtube/calendar'}
            title={
              _t('influencers:Videos_calendar') +
              ` ${isReport ? `( ${_t('reports:youtube')} )` : ''}`
            }
            setActiveTab={setActiveTab}
            setOpenTab={setOpenTab}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_youtube_analyze_videos_calendar'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
            customFilters={{ channel_id, is_sample: checkIsTemplate }}
            upToDate={handelAnalyzedCalender}
          />
        </Grid>
      ),
    },
    {
      id: 'influencers_youtube_analyze_channel_activity',
      component: (
        <Grid item lg={8} sm={12}>
          <BaseLine
            baseLineTitle={
              _t('videos:channel_activity') +
              ` ${isReport ? `( ${_t('reports:youtube')} )` : ''}`
            }
            slugName={influencerApiRoutes().channelActivities}
            withYearTime={isReport}
            showCustomTooltip
            hideNames
            noDayInTimeInterval={!isReport}
            timeIntervalFilter={!isReport}
            customFilters={{
              channel_ids: [youtubeData?.channel_id],
              channel_id,
              limit: 5,
              is_sample: checkIsTemplate,
            }}
            compId={'influencers_youtube_analyze_channel_activity'}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_youtube_analyze_channel_activity'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        </Grid>
      ),
    },
    {
      id: 'influencers_youtube_analyze_similar_channels',
      component: (
        <Grid item lg={4} sm={12}>
          <SecondaryTable
            tableCardTitle={
              _t('influencers:similar_channels') +
              ` ${isReport ? `( ${_t('reports:youtube')} )` : ''}`
            }
            compId={'influencers_youtube_analyze_similar_channels'}
            columns={relatedChannelsColumns}
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().youtubeRelatedChannel
                : entitiesApiRoutes().youtubeRelatedChannel
            }
            hideFilters
            customFilters={customYoutubeFilters}
            hideToggleView
            expandAction={
              isReport
                ? undefined
                : () => {
                    window.scrollTo(0, 0);
                    setActiveTab(1);
                    setOpenTab(2);
                  }
            }
            hideIfNoData={!isReport || isInDownloadCharts}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_youtube_analyze_similar_channels'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        </Grid>
      ),
    },
  ];
  const renderTwitterCharts: TRenderCharts = [
    {
      id: 'influencers_twitter_analyze_created_date',
      component: (
        <IconCard
          compId={'influencers_twitter_analyze_created_date'}
          title={
            _t('influencers:Created_date') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          withFilter={!isReport}
          hideInput
          cardData={{
            icon: <CalenderIcon />,
            count: twitterData?.created_at,
            countName: 'Created Date',
          }}
          hideDay
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_twitter_analyze_created_date'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_followers',
      component: (
        <IconCard
          compId={'influencers_twitter_analyze_followers'}
          withFilter={!isReport}
          title={
            _t('influencers:Followers') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          cardData={{
            icon: <FollowerIcon />,
            countName: 'Followers',
          }}
          customFilters={customTwitterFilters}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().twitterAnalyzedFollower
              : entitiesApiRoutes().twitterAnalyzedFollower
          }
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_twitter_analyze_followers'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_following',
      component: (
        <IconCard
          withFilter={!isReport}
          compId={'influencers_twitter_analyze_following'}
          title={
            _t('influencers:Following') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          cardData={{
            icon: <FollowingIcon />,
            countName: 'Follwing',
          }}
          customFilters={customTwitterFilters}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().twitterAnalyzedFollowing
              : entitiesApiRoutes().twitterAnalyzedFollowing
          }
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_twitter_analyze_following'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_tweets',
      component: (
        <IconCard
          withFilter={!isReport}
          compId={'influencers_twitter_analyze_tweets'}
          title={
            _t('influencers:Tweets') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          cardData={{
            icon: <InfTwitter />,
            countName: 'tweet',
          }}
          customFilters={customTwitterFilters}
          slug={tweetsChartSlug}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={addCommentComponent(
            'influencers_twitter_analyze_tweets',
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_tweets_likes',
      component:
        twitterData?.likes_count === 0 ? (
          <></>
        ) : (
          <IconCard
            compId={'influencers_twitter_analyze_tweets_likes'}
            withFilter={!isReport}
            hideInput
            title={
              _t('basic:likes') +
              ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
            }
            cardData={{
              icon: <BigHeartIcon />,
              count: twitterData?.likes_count,
              // countName: 'times',
            }}
            hideIfNoData={!isReport || isInDownloadCharts}
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_twitter_analyze_tweets_likes'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ),
    },
    {
      id: 'influencers_twitter_analyze_reach',
      component:
        twitterData?.reach === 0 ? (
          <></>
        ) : (
          <IconCard
            compId={'influencers_twitter_analyze_reach'}
            title={
              _t('influencers:reach') +
              ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
            }
            withFilter={!isReport}
            hideInput
            cardData={{
              icon: <UserNetworkIcon />,
              count: twitterData?.reach,
            }}
            hideDay
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            hideIfNoData={!isReport || isInDownloadCharts}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_twitter_analyze_reach'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ),
    },
    {
      id: 'influencers_twitter_analyze_impression',
      component:
        twitterData?.impressions === 0 ? (
          <></>
        ) : (
          <IconCard
            compId={'influencers_twitter_analyze_impression'}
            title={
              _t('influencers:impression') +
              ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
            }
            withFilter={!isReport}
            hideInput
            cardData={{
              icon: <ImpressionIcon />,
              count: twitterData?.impressions,
            }}
            hideDay
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            hideIfNoData={!isReport || isInDownloadCharts}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_twitter_analyze_impression'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ),
    },
    {
      id: 'influencers_twitter_analyze_tweets_sentiment',
      component:
        influencerDetails?.status === 'ANALYZED' || isTemplate || isReport ? (
          <DonutChart
            donutTitle={
              _t('trends:sentiment') +
              ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
            }
            limit={5}
            showFilter
            hideInput
            customFilters={customTwitterFilters}
            title={_t('influencers:Tweets')}
            compId={'influencers_twitter_analyze_tweets_sentiment'}
            slug={
              isInfluencerModule
                ? influencerApiRoutes().twitterAnalyzedTweetSentiment
                : entitiesApiRoutes().twitterAnalyzedTweetSentiment
            }
            hideIfNoData={!isReport || isInDownloadCharts}
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_twitter_analyze_tweets_sentiment'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_twitter_analyze_average_interval_between_tweets',
      component: (
        <IconCard
          compId={'influencers_twitter_analyze_average_interval_between_tweets'}
          withFilter={!isReport}
          hideInput
          title={
            _t('influencers:average_interval_between_tweets') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          cardData={{
            icon: <TweetsInterval />,
            count:
              twitterData?.has_tweets === false
                ? '-'
                : twitterData?.avg_interval_between_tweets,
            countName: twitterData?.has_tweets
              ? twitterData?.avg_interval_between_tweets < 10
                ? twitterData?.avg_interval_between_tweets === 1
                  ? _t('basic:one_hour')
                  : _t('basic:hours')
                : _t('basic:hour')
              : '',
          }}
          showCountName
          hideIfNoData={!isReport || isInDownloadCharts}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={
                'influencers_twitter_analyze_average_interval_between_tweets'
              }
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_most_active_time',
      component: (
        <IconCard
          compId={'influencers_twitter_analyze_most_active_time'}
          title={
            _t('influencers:Most_active_time') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          withFilter={!isReport}
          hideInput
          cardData={{
            icon: <ClockIcon />,
            count:
              twitterData?.has_tweets === false
                ? '-'
                : twitterData?.most_active_time,
            countName:
              twitterData?.has_tweets === false ? '' : _t('basic:o_clock'),
          }}
          showCountName
          fliptextdirection={isAr}
          hideIfNoData={!isReport || isInDownloadCharts}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_twitter_analyze_most_active_time'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_timeframe',
      component: (
        <IconCard
          compId={'influencers_twitter_analyze_timeframe'}
          title={
            _t('influencers:time_frame') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          withFilter={!isReport}
          hideInput
          cardData={{
            icon: <TimeFrameIcon />,
            count: 'noShow',
            countName:
              twitterData?.has_tweets === false
                ? '-'
                : checkNumberOfDays(nFormatter(twitterData?.timeframe)),
          }}
          showCountName
          fliptextdirection={isAr}
          hideIfNoData={!isReport || isInDownloadCharts}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_twitter_analyze_timeframe'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_tweets_per_day',
      component: (
        <IconCard
          compId={'influencers_twitter_analyze_tweets_per_day'}
          withFilter={!isReport}
          hideInput
          title={
            _t('influencers:Tweets_Per_Day') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          cardData={{
            icon: <TweetsInterval />,
            count:
              twitterData?.has_tweets === false
                ? '-'
                : twitterData?.tweets_count,
            countName: twitterData?.has_tweets === false ? '' : 'times',
          }}
          hideIfNoData={!isReport || isInDownloadCharts}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_twitter_analyze_tweets_per_day'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_tweets_by_language',
      component: (
        <DonutChart
          donutTitle={
            _t('influencers:tweets_by_language') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          limit={5}
          showFilter
          hideInput
          customFilters={customTwitterFilters}
          title={_t('influencers:Tweets')}
          compId={'influencers_twitter_analyze_tweets_by_language'}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().twitterAnalyzedTweetTweetsByLanguage
              : entitiesApiRoutes().twitterAnalyzedTweetTweetsByLanguage
          }
          hideIfNoData={!isReport || isInDownloadCharts}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_twitter_analyze_tweets_by_language'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_tweet_classification',
      component: (
        <DonutChart
          donutTitle={
            _t('influencers:tweets_media') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          limit={5}
          showFilter
          hideInput
          customFilters={customTwitterFilters}
          title={_t('influencers:Tweets')}
          compId={'influencers_twitter_analyze_tweet_classification'}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().twitterAnalyzedTweetsTypesChart
              : entitiesApiRoutes().twitterAnalyzedTweetsTypesChart
          }
          hideIfNoData={!isReport || isInDownloadCharts}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_twitter_analyze_tweet_classification'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_tweets_last_tweet_per_day',
      component: (
        <IconCard
          compId={'influencers_twitter_analyze_tweets_last_tweet_per_day'}
          withFilter={!isReport}
          hideInput
          title={
            _t('influencers:last_tweet_per_day') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          showCountName
          cardData={{
            icon: <LastTweetPerDayIcon />,
            count: 'noShow',
            countName:
              twitterData?.has_tweets === false
                ? '-'
                : checkDay(nFormatter(twitterData?.last_tweet_day)),
          }}
          hideIfNoData={!isReport || isInDownloadCharts}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_twitter_analyze_tweets_last_tweet_per_day'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_tweets_last_tweet_client',
      component: twitterData?.last_tweet_source?.length ? (
        <IconCard
          compId={'influencers_twitter_analyze_tweets_last_tweet_client'}
          withFilter={!isReport}
          hideInput
          title={
            _t('influencers:last_tweet_client') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          showCountName
          cardData={{
            icon: <LastTweetClientIcon />,
            count: 'noShow',
            countName: twitterData?.last_tweet_source,
          }}
          hideIfNoData={!isReport || isInDownloadCharts}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_twitter_analyze_tweets_last_tweet_client'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ) : (
        <></>
      ),
    },

    {
      id: 'influencers_twitter_analyze_tweet_types',
      component: (
        <DonutChart
          donutTitle={
            _t('influencers:tweets_type') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          limit={5}
          showFilter
          hideInput
          customFilters={customTwitterFilters}
          title={_t('influencers:Tweets')}
          compId={'influencers_twitter_analyze_tweet_types'}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().twitterAnalyzedTweetsClassificationChart
              : entitiesApiRoutes().twitterAnalyzedTweetsClassificationChart
          }
          hideIfNoData={!isReport || isInDownloadCharts}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_twitter_analyze_tweet_types'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_tweet_calendar',
      component: (
        <Grid item lg={4} sm={12}>
          <FullCalendarBlock
            compId={'influencers_twitter_analyze_tweet_calendar'}
            id={checkIsTemplate ? influencer_id.twitter : influencer_id}
            slug="details/twitter/calendar"
            isInfluencerModule={isInfluencerModule}
            title={
              _t('influencers:tweet_calendar') +
              ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
            }
            setActiveTab={setActiveTab}
            setOpenTab={setOpenTab}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_twitter_analyze_tweet_calendar'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
            customFilters={{ twitter_profile_id, is_sample: checkIsTemplate }}
            upToDate={handelAnalyzedCalender}
          />
        </Grid>
      ),
    },
    {
      id: 'influencers_twitter_analyze_top_geo_locations',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={
            _t('influencers:top_geo_loactions') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          compId={'influencers_twitter_analyze_top_geo_locations'}
          columns={topGeoLocations}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().influencerLocationHistory
              : entitiesApiRoutes().influencerLocationHistory
          }
          hideFilters
          customFilters={customTwitterFilters}
          notPlatforms
          hideToggleView
          distributed
          expandAction={
            isReport
              ? undefined
              : () => {
                  window.scrollTo(0, 0);
                  setActiveTab(1);
                  setOpenTab(5);
                }
          }
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={
                isInfluencerModule
                  ? 'influencers_twitter_analyze_top_geo_locations'
                  : 'entities_twitter_analyze_top_geo_locations'
              }
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_top_people_in_conversation',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={
            _t('influencers:top_people_in_conversation') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          compId={'influencers_twitter_analyze_top_people_in_conversation'}
          columns={topPeopleConversation}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().twitterAnalyzedTopPeopleConversation
              : entitiesApiRoutes().twitterAnalyzedTopPeopleConversation
          }
          hideFilters
          customFilters={customTwitterFilters}
          notPlatforms
          hideToggleView
          distributed
          expandAction={
            isReport
              ? undefined
              : () => {
                  window.scrollTo(0, 0);
                  setActiveTab(1);
                  setOpenTab(3);
                }
          }
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={
                isInfluencerModule
                  ? 'influencers_twitter_analyze_top_people_in_conversation'
                  : 'entities_twitter_analyze_top_people_in_conversation'
              }
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_top_words',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={
            _t('influencers:top_words') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          compId={'influencers_twitter_analyze_top_words'}
          columns={topWords}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().twitterAnalyzedTweetTopWords
              : entitiesApiRoutes().twitterAnalyzedTweetTopWords
          }
          hideFilters
          customFilters={customTwitterFilters}
          notPlatforms
          distributed
          hideToggleView
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_twitter_analyze_top_words'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_frequent_used_hashtags',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={
            _t('influencers:frequent_used_hashtags') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          compId={'influencers_twitter_analyze_frequent_used_hashtags'}
          columns={frequentHashtags}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().twitterAnalyzedFrequentHashtags
              : entitiesApiRoutes().twitterAnalyzedFrequentHashtags
          }
          hideFilters
          customFilters={customTwitterFilters}
          notPlatforms
          distributed
          hideToggleView
          expandAction={
            isReport
              ? undefined
              : () => {
                  window.scrollTo(0, 0);
                  setActiveTab(1);
                  setOpenTab(2);
                }
          }
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_twitter_analyze_frequent_used_hashtags'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_recent_images',
      component: (
        <RecentMedia
          customFilters={{
            influencer_id: checkIsTemplate
              ? influencer_id.twitter
              : influencer_id,
            limit: 8,
            twitter_profile_id,
            is_sample: checkIsTemplate,
          }}
          slugName={
            isInfluencerModule
              ? influencerApiRoutes().twitterAnalyzeMedia
              : entitiesApiRoutes().twitterAnalyzeMedia
          }
          expandAction={
            isReport
              ? undefined
              : () => {
                  window.scrollTo(0, 0);
                  setActiveTab(1);
                  setOpenTab(6);
                }
          }
          compId={'influencers_twitter_analyze_recent_images'}
          title={
            _t('influencers:recentimgaes') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          hideIfNoData={!isReport || isInDownloadCharts}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_twitter_analyze_recent_images'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_tweets_baseline',
      component: (
        <Grid item lg={8} sm={12}>
          <BaseLine
            compId={'influencers_twitter_analyze_tweets_baseline'}
            withYearTime={isReport}
            baseLineTitle={
              _t('influencers:Tweets') +
              ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
            }
            slugName={
              isInfluencerModule
                ? influencerApiRoutes().twitterAnalyzedTweetsTweetsBaseLine
                : entitiesApiRoutes().twitterAnalyzedTweetsTweetsBaseLine
            }
            customFilters={customTwitterFilters}
            showDefaultTooltip
            noDayInTimeInterval={!isReport}
            timeIntervalFilter={!isReport}
            hideNames
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_twitter_analyze_tweets_baseline'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        </Grid>
      ),
    },
    {
      id: 'influencers_twitter_analyze_tweet_clients',
      component: (
        <DonutChart
          donutTitle={
            _t('influencers:tweet_clients') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          limit={5}
          showFilter
          hideInput
          title={_t('influencers:Tweets')}
          compId={'influencers_twitter_analyze_tweet_clients'}
          customFilters={{
            influencer_id: checkIsTemplate
              ? influencer_id.twitter
              : influencer_id,
            twitter_profile_id,
            limit: 5,
            is_sample: checkIsTemplate,
          }}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().twitterAnalyzedTweetClients
              : entitiesApiRoutes().twitterAnalyzedTweetClients
          }
          hideIfNoData={!isReport || isInDownloadCharts}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_twitter_analyze_tweet_clients'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_top_mentions',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={
            _t('influencers:top_mentions') +
            ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
          }
          compId={'influencers_twitter_analyze_top_mentions'}
          columns={topMentions}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().twitterMentionsTab
              : entitiesApiRoutes().twitterMentionsTab
          }
          hideFilters
          customFilters={customTwitterFilters}
          notPlatforms
          hideToggleView
          distributed
          hideCountry
          expandAction={
            isReport
              ? undefined
              : () => {
                  window.scrollTo(0, 0);
                  setActiveTab(1);
                  setOpenTab(4);
                }
          }
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={
                isInfluencerModule
                  ? 'influencers_twitter_analyze_top_mentions'
                  : 'entities_twitter_analyze_top_mentions'
              }
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_twitter_analyze_gained_followers',
      component: (
        <Grid item lg={8} sm={12}>
          <BaseLine
            compId={'influencers_twitter_analyze_gained_followers'}
            baseLineTitle={
              _t('influencers:gained_followers') +
              ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
            }
            slugName={
              isInfluencerModule
                ? influencerApiRoutes().twitterAnalyzedTweetsFollowersBaseLine
                : entitiesApiRoutes().twitterAnalyzedTweetsFollowersBaseLine
            }
            customFilters={customTwitterFilters}
            withYearTime={isReport}
            timeIntervalFilter={!isReport}
            noDayInTimeInterval={!isReport}
            hideNames
            showDefaultTooltip
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_twitter_analyze_gained_followers'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        </Grid>
      ),
    },
    {
      id: 'influencers_twitter_analyze_tweets_clients_per_hours',
      component: (
        <Grid item lg={8} sm={12}>
          <BaseLine
            baseLineTitle={
              _t('influencers:tweet_clients') +
              ` ${isReport ? `( ${_t('reports:twitter')} )` : ''}`
            }
            slugName={
              isInfluencerModule
                ? influencerApiRoutes().twitterTweetClients
                : entitiesApiRoutes().twitterTweetClients
            }
            hideIfNoData={!isReport || isInDownloadCharts}
            showCustomTooltip
            tooltipTitle={[_t('influencers:tweet_clients'), _t('basic:count')]}
            hideNames
            withYearTime={isReport || isTemplate}
            timeIntervalFilter={!isReport}
            defaultTimeInterval={'YEAR'}
            customFilters={{
              limit: 5,
              influencer_id: checkIsTemplate
                ? influencer_id.twitter
                : influencer_id,
              twitter_profile_id,
              is_sample: checkIsTemplate,
            }}
            compId={'influencers_twitter_analyze_tweets_clients_per_hours'}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_twitter_analyze_tweets_clients_per_hours'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        </Grid>
      ),
    },
  ];
  const renderAuthorCharts: any = [
    {
      id: 'influencers_author_analyze_news_article',
      component: (
        <IconCard
          compId={'influencers_author_analyze_news_article'}
          cardData={{ icon: <NewsArticle /> }}
          title={
            _t('news:news_article') +
            ` ${isReport ? `( ${_t('reports:author')} )` : ''}`
          }
          withFilter={!isReport}
          hideIfNoData={!isReport || isInDownloadCharts}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().InfluncerAuthorArticleCount
              : entitiesApiRoutes().entityAuthorArticleCount
          }
          customFilters={customAuthorFilters}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_author_analyze_news_article'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_author_analyze_total_sources',
      component: (
        <IconCard
          compId={'influencers_author_analyze_total_sources'}
          cardData={{ icon: <NewsTotalSources /> }}
          title={
            _t('news:total_sources') +
            ` ${isReport ? `( ${_t('reports:author')} )` : ''}`
          }
          slug={
            isInfluencerModule
              ? influencerApiRoutes().InfluncerAuthorSourcesCount
              : entitiesApiRoutes().entityAuthorSourcesCount
          } //temp going to be changed
          customFilters={customAuthorFilters}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_author_analyze_total_sources'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_author_analyze_articles_month',
      component: (
        <IconCard
          compId={'influencers_author_analyze_articles_month'}
          cardData={{ icon: <NewsArticle /> }}
          title={
            _t('news:articles_per_month') +
            ` ${isReport ? `( ${_t('reports:author')} )` : ''}`
          }
          slug={
            isInfluencerModule
              ? influencerApiRoutes().InfluncerAuthorArticleAverage
              : entitiesApiRoutes().entityAuthorArticleAverage
          } //temp going to be changed
          customFilters={customAuthorFilters}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_author_analyze_articles_month'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_author_analyze_top_words',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={
            _t('influencers:top_words') +
            ` ${isReport ? `( ${_t('reports:author')} )` : ''}`
          }
          compId={'influencers_author_analyze_top_words'}
          columns={topWords}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().newsTabAuthorTopWords
              : entitiesApiRoutes().newsTabAuthorTopWords
          }
          hideFilters
          customFilters={customAuthorFilters}
          notPlatforms
          distributed
          hideToggleView
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_author_analyze_top_words'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_author_analyze_author_source',
      component: (
        <Grid item lg={4} sm={12}>
          <SecondaryTable
            tableCardTitle={
              _t('news:author_sorce') +
              ` ${isReport ? `( ${_t('reports:author')} )` : ''}`
            }
            compId={'influencers_author_analyze_author_source'}
            hideFilters
            expandAction={
              isReport
                ? undefined
                : () => {
                    window.scrollTo(0, 0);
                    setActiveTab(1);
                    setOpenTab(2);
                  }
            }
            hideToggleView
            columns={authorSouceCols}
            data={authorSouceCols}
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().InfluncerAuthorSources
                : entitiesApiRoutes().entityAuthorSources
            } //temp going to be changed
            customFilters={customAuthorFilters}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_author_analyze_author_source'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        </Grid>
      ),
    },
    {
      id: 'influencers_author_analyze_author_tags',
      component: (
        <Grid item lg={4} sm={12}>
          <SecondaryTable
            tableCardTitle={
              _t('news:frequently_used_tags') +
              ` ${isReport ? `( ${_t('reports:author')} )` : ''}`
            }
            compId={'influencers_author_analyze_author_tags'}
            hideFilters
            expandAction={
              isReport
                ? undefined
                : () => {
                    window.scrollTo(0, 0);
                    setActiveTab(1);
                    setOpenTab(3);
                  }
            }
            hideToggleView
            columns={freqUsesCols}
            data={freqUsesCols}
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().InfluncerAuthorTags
                : entitiesApiRoutes().entityAuthorTags
            } //temp going to be changed
            customFilters={customAuthorFilters}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_author_analyze_author_tags'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        </Grid>
      ),
    },
    {
      id: 'influencers_author_analyze_sentiment',
      component:
        influencerDetails?.status === 'ANALYZED' || isTemplate || isReport ? (
          <DonutChart
            donutTitle={
              _t('trends:sentiment') +
              ` ${isReport ? `( ${_t('reports:author')} )` : ''}`
            }
            limit={5}
            showFilter
            hideInput
            customFilters={customAuthorFilters}
            title={_t('influencers:articles')}
            compId={'influencers_author_analyze_sentiment'}
            slug={
              isInfluencerModule
                ? influencerApiRoutes().authorAnalyzedTweetSentiment
                : entitiesApiRoutes().authorAnalyzedTweetSentiment
            }
            hideIfNoData={!isReport || isInDownloadCharts}
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_author_analyze_sentiment'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_author_analyze_articles_calander',
      component: (
        <Grid item lg={4} sm={12}>
          <FullCalendarBlock
            slug={
              isInfluencerModule
                ? influencerApiRoutes().InfluncerAuthorCalander
                : entitiesApiRoutes().entityAuthorCalander
            } //temp going to be changed
            title={
              _t('news:article_calander') +
              ` ${isReport ? `( ${_t('reports:author')} )` : ''}`
            }
            compId={'influencers_author_analyze_articles_calander'}
            setActiveTab={setActiveTab}
            author
            customFilters={{ is_sample: checkIsTemplate }}
            id={checkIsTemplate ? influencer_id.author : influencer_id}
            setOpenTab={setOpenTab}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_author_analyze_articles_calander'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
            upToDate={handelAnalyzedCalender}
          />
        </Grid>
      ),
    },
    {
      id: 'influencers_author_analyze_articles',
      component: (
        <Grid item lg={8} sm={12}>
          <BaseLine
            slugName={
              isInfluencerModule
                ? influencerApiRoutes().InfluncerAuthorArticleChart
                : entitiesApiRoutes().entityAuthorArticleChart
            } //temp going to be changed
            customFilters={customAuthorFilters}
            compId={'influencers_author_analyze_articles'}
            baseLineTitle={
              _t('news:articles') +
              ` ${isReport ? `( ${_t('reports:author')} )` : ''}`
            }
            timeIntervalFilter={!isReport}
            withYearTime={isReport}
            noDayInTimeInterval={!isReport}
            hideNames
            removeTooltip
            showDefaultTooltip
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_author_analyze_articles'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        </Grid>
      ),
    },
    (isReport || isTemplate) && {
      id: 'influencers_twitter_followers',
      component: (
        <Grid item lg={isTemplate && 6} sm={12}>
          <TwitterFollowersTab
            isInfluencerModule={isInfluencerModule}
            id={checkIsTemplate ? influencer_id.twitter : influencer_id}
            isReport={true}
            compId={'influencers_twitter_followers'}
            customFilters={{ is_sample: checkIsTemplate }}
            influencer_id={
              checkIsTemplate ? influencer_id.twitter : influencer_id
            }
          />
        </Grid>
      ),
    },

    (isReport || isTemplate) && {
      id: 'influencers_twitter_following',
      component: (
        <Grid item lg={isTemplate && 6} sm={12}>
          <TwitterFollowingTab
            isInfluencerModule={isInfluencerModule}
            id={checkIsTemplate ? influencer_id.twitter : influencer_id}
            isReport={true}
            compId={'influencers_twitter_following'}
            customFilters={{ is_sample: checkIsTemplate }}
            influencer_id={
              checkIsTemplate ? influencer_id.twitter : influencer_id
            }
          />
        </Grid>
      ),
    },
  ].filter(Boolean);
  const isDownload = pathname.includes('charts/download');

  const relatedInfluencersColumns: TRenderCharts = [
    {
      id: 'influencers_related_influencers',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_influencers'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().allRelatedInfluencers
                : entitiesApiRoutes().allRelatedInfluencers
            }
            defaultTab={'allColumns'}
            columns={
              isInfluencerModule
                ? getInfluencerRelatedInfluencers(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).allColumns
                : getEntityRelatedInfluencers(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).allColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_influencers')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_influencers'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('influencers:related_influencers')} ( ${_t(
                'basic:all',
              )} )`}
              compId={'influencers_related_influencers'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_influencers_friend',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_influencers_friend'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={influencerApiRoutes().friendsRelatedInfluencers}
            defaultTab={'friends'}
            columns={
              getInfluencerRelatedInfluencers(
                checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                true,
              ).friendsColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_influencers_friend')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_influencers_friend'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('influencers:related_influencers')} ( ${_t(
                'influencers:friends',
              )} )`}
              compId={'influencers_related_influencers_friend'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_influencers_relative',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_influencers_relative'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={influencerApiRoutes().relativesRelatedInfluencers}
            defaultTab={'relatives'}
            columns={
              getInfluencerRelatedInfluencers(
                checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                true,
              ).relativesColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_influencers_relative')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_influencers_relative'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('influencers:related_influencers')} ( ${_t(
                'influencers:relatives',
              )} )`}
              compId={'influencers_related_influencers_relative'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_influencers_coworker',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_influencers_coworker'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().coworkersRelatedInfluencers
                : entitiesApiRoutes().coworkersRelatedInfluencers
            }
            defaultTab={'coworkers'}
            columns={
              isInfluencerModule
                ? getInfluencerRelatedInfluencers(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).coworkersColumns
                : getEntityRelatedInfluencers(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).byOrganizationColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_influencers_coworker')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_influencers_coworker'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('influencers:related_influencers')} ( ${
                isInfluencerModule
                  ? _t('influencers:coworkers')
                  : _t('basic:by_organization')
              } )`}
              compId={'influencers_related_influencers_coworker'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_influencers_mention',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_influencers_mention'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().mentionsRelatedInfluencers
                : entitiesApiRoutes().mentionsRelatedInfluencers
            }
            defaultTab={'mentions'}
            columns={
              isInfluencerModule
                ? getInfluencerRelatedInfluencers(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).mentionsColumns
                : getEntityRelatedInfluencers(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).mentionsColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_influencers_mention')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_influencers_mention'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('influencers:related_influencers')} ( ${_t(
                'basic:mentions',
              )} )`}
              compId={'influencers_related_influencers_mention'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_entities',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_entities'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().allRelatedEntities
                : entitiesApiRoutes().allRelatedEntities
            }
            defaultTab={'allEntities'}
            columns={
              isInfluencerModule
                ? getInfluencerRelatedEntities(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).allColumns
                : getEntityRelatedEntities(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).allColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_entities')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_entities'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('entities:related_entities')} ( ${_t(
                'basic:all',
              )} )`}
              compId={'influencers_related_entities'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_entities_study_place',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_entities_study_place'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={influencerApiRoutes().schoolUniversityRelatedEntities}
            columns={
              getInfluencerRelatedEntities(
                checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                true,
              ).schoolUniversityColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            defaultTab="school_university"
            rowsLimit={getItemCount('influencers_related_entities_study_place')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_entities_study_place'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('entities:related_entities')} ( ${_t(
                'influencers:school_university',
              )} )`}
              compId={'influencers_related_entities_study_place'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_influencers_fellow_student',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_influencers_fellow_student'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={influencerApiRoutes().fellowStudentsInfluencers}
            columns={
              getInfluencerRelatedInfluencers(
                checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                true,
              ).fellowStudents
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            defaultTab="fellow_students"
            rowsLimit={getItemCount(
              'influencers_related_influencers_fellow_student',
            )}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_influencers_fellow_student'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('influencers:related_influencers')} ( ${_t(
                'influencers:fellow_students',
              )} )`}
              compId={'influencers_related_influencers_fellow_student'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_entities_workplace',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_entities_workplace'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().coworkersRelatedEntities
                : entitiesApiRoutes().coworkersRelatedEntities
            }
            defaultTab={'mentions'}
            columns={
              isInfluencerModule
                ? getInfluencerRelatedEntities(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).coworkersColumns
                : getEntityRelatedEntities(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).byOrganizationColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_entities_workplace')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_entities_workplace'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('entities:related_entities')} ( ${
                isInfluencerModule
                  ? _t('basic:workplace')
                  : _t('basic:by_organization')
              } )`}
              compId={'influencers_related_entities_workplace'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_entities_mention',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_entities_mention'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().mentionsRelatedEntities
                : entitiesApiRoutes().mentionsRelatedEntities
            }
            defaultTab={'mentions'}
            columns={
              isInfluencerModule
                ? getInfluencerRelatedEntities(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).mentionsColumns
                : getEntityRelatedEntities(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).mentionsColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_entities_mention')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_entities_mention'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('entities:related_entities')} ( ${_t(
                'basic:mentions',
              )} )`}
              compId={'influencers_related_entities_mention'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
  ];
  const renderLinkedInCharts: TRenderCharts = [
    {
      id: 'influencers_linkedin_analyze_followers',
      component: (
        <IconCard
          compId={'influencers_linkedin_analyze_followers'}
          withFilter={!isReport}
          title={
            _t('influencers:Followers') +
            ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
          }
          cardData={{
            icon: <FollowerIcon />,
            countName: 'Followers',
          }}
          hideEmptyCount={!is_full_grabbed}
          customFilters={customLinkedInFilters}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().linkedAnalyzedFollowers
              : entitiesApiRoutes().linkedAnalyzedFollowers
          }
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_linkedin_analyze_followers'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_linkedin_analyze_employee_on_linkedin',
      component: !isInfluencerModule ? (
        <IconCard
          compId={'influencers_linkedin_analyze_employee_on_linkedin'}
          withFilter={!isReport}
          title={
            _t('entities:employee_on_linkedin') +
            ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
          }
          cardData={{
            icon: <EmployeeIcon />,
            countName: 'Followers',
          }}
          customFilters={customLinkedInFilters}
          slug={entitiesApiRoutes().linkedAnalyzedEmployeeOnLinkedin}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_linkedin_analyze_employee_on_linkedin'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ) : (
        <></>
      ),
    },
    {
      id: 'influencers_linkedin_analyze_recent_activity_time',
      component: isInfluencerModule ? (
        <IconCard
          compId={'influencers_linkedin_analyze_recent_activity_time'}
          withFilter={!isReport}
          hideInput
          title={
            _t('influencers:recent_activity_time') +
            ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
          }
          showCountName
          customFilters={customLinkedInFilters}
          cardData={{
            icon: <RecentActivityTime />,
            count: 'noShow',
            countName:
              linkedInData?.recent_active_time === 0
                ? '-'
                : checkTime(
                    nFormatter(linkedInData?.recent_active_time.value) as any,
                    linkedInData?.recent_active_time.label,
                  ),
          }}
          hideIfNoData={!isReport || isInDownloadCharts}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_linkedin_analyze_recent_activity_time'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ) : (
        <></>
      ),
    },
    {
      id: 'influencers_linkedin_analyze_open_job',
      component: !isInfluencerModule ? (
        <IconCard
          compId={'influencers_linkedin_analyze_open_job'}
          withFilter={!isReport}
          hideInput
          title={
            _t('entities:open_job') +
            ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
          }
          slug={entitiesApiRoutes().linkedAnalyzedOpenJob}
          customFilters={customLinkedInFilters}
          cardData={{
            icon: <OpenJobsIcon />,
          }}
          hideIfNoData={!isReport || isInDownloadCharts}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_linkedin_analyze_open_job'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ) : (
        <></>
      ),
    },
    {
      id: 'influencers_linkedin_analyze_top_words',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={
            _t('influencers:top_words') +
            ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
          }
          compId={'influencers_linkedin_analyze_top_words'}
          columns={topWords}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().linkedAnalyzedTopWords
              : entitiesApiRoutes().linkedAnalyzedTopWords
          }
          hideFilters
          customFilters={customLinkedInFilters}
          notPlatforms
          distributed
          hideToggleView
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_linkedin_analyze_top_words'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_linkedin_analyze_recent_post',
      component:
        is_full_grabbed || isReport ? (
          <SecondaryTable
            tableCardTitle={
              _t('influencers:recent_post') +
              ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
            }
            compId={'influencers_linkedin_analyze_recent_post'}
            columns={recentPostsColumns}
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().linkedAnalyzedRecentPost
                : entitiesApiRoutes().linkedAnalyzedRecentPost
            }
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            hideFilters
            customFilters={customLinkedInFilters}
            hideToggleView
            expandAction={
              isReport
                ? undefined
                : () => {
                    window.scrollTo(0, 0);
                    setActiveTab(1);
                    setOpenTab(0);
                  }
            }
            hideIfNoData={!isReport || isInDownloadCharts}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_linkedin_analyze_recent_post'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_linkedin_analyze_frequent_used_hashtags',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={
            _t('influencers:frequent_used_hashtags') +
            ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
          }
          compId={'influencers_linkedin_analyze_frequent_used_hashtags'}
          columns={frequentHashtags}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().linkedinHashtags
              : entitiesApiRoutes().linkedinHashtags
          }
          hideFilters
          customFilters={customLinkedInFilters}
          notPlatforms
          distributed
          hideToggleView
          expandAction={
            isReport
              ? undefined
              : () => {
                  window.scrollTo(0, 0);
                  setActiveTab(1);
                  setOpenTab(2);
                }
          }
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_linkedin_analyze_frequent_used_hashtags'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_linkedin_analyze_posts_classification',
      component:
        is_full_grabbed || isReport ? (
          <DonutChart
            donutTitle={
              _t('influencers:posts_classification') +
              ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
            }
            limit={5}
            hideInput
            exportIcon
            customFilters={customLinkedInFilters}
            title={_t('influencers:posts')}
            compId={'influencers_linkedin_analyze_posts_classification'}
            slug={
              isInfluencerModule
                ? influencerApiRoutes().linkedAnalyzedPostClassifications
                : entitiesApiRoutes().linkedAnalyzedPostClassifications
            }
            hideIfNoData={!isReport || isInDownloadCharts}
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_linkedin_analyze_posts_classification'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_linkedin_analyze_posts_by_language',
      component: (
        <DonutChart
          donutTitle={
            _t('influencers:posts_by_language') +
            ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
          }
          limit={5}
          hideInput
          exportIcon
          customFilters={customLinkedInFilters}
          title={_t('influencers:posts')}
          compId={'influencers_linkedin_analyze_posts_by_language'}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().linkedAnalyzedPostLanguage
              : entitiesApiRoutes().linkedAnalyzedPostLanguage
          }
          hideIfNoData={!isReport || isInDownloadCharts}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_linkedin_analyze_posts_by_language'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_linkedin_analyze_sentiment',
      component:
        (influencerDetails?.status === 'ANALYZED' && is_full_grabbed) ||
        isTemplate ||
        isReport ? (
          <DonutChart
            donutTitle={
              _t('trends:sentiment') +
              ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
            }
            limit={5}
            showFilter
            hideInput
            customFilters={customLinkedInFilters}
            title={_t('influencers:posts')}
            compId={'influencers_linkedin_analyze_sentiment'}
            slug={
              isInfluencerModule
                ? influencerApiRoutes().linkedAnalyzedPostSentiment
                : entitiesApiRoutes().linkedAnalyzedPostSentiment
            }
            hideIfNoData={!isReport || isInDownloadCharts}
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_linkedin_analyze_sentiment'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_linkedin_analyze_top_people',
      component:
        (influencerDetails?.status === 'ANALYZED' && is_full_grabbed) ||
        isTemplate ||
        isReport ? (
          <Grid item lg={4} sm={12}>
            <SecondaryTable
              tableCardTitle={
                _t('influencers:top_people') +
                ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
              }
              compId={'influencers_linkedin_analyze_top_people'}
              columns={topPeopleConversation}
              moduleName={influencerApiRoutes().linkedAnalyzedTopPeople}
              hideFilters
              customFilters={customLinkedInFilters}
              hideToggleView
              expandAction={
                isReport
                  ? undefined
                  : () => {
                      window.scrollTo(0, 0);
                      setActiveTab(1);
                      setOpenTab(3);
                    }
              }
              hideIfNoData={!isReport || isInDownloadCharts}
              additionalComponents={checkIsReport(
                <AddComment
                  {...report}
                  compId={'influencers_linkedin_analyze_top_people'}
                  id={influencer_id}
                />,
              )}
              isReport={isReport}
            />
          </Grid>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_linkedin_analyze_posts_baseline',
      component: (
        <Grid item lg={8} sm={12}>
          <BaseLine
            compId={'influencers_linkedin_analyze_posts_baseline'}
            withYearTime={isReport}
            baseLineTitle={
              _t('influencers:posts') +
              ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
            }
            slugName={
              isInfluencerModule
                ? influencerApiRoutes().linkedAnalyzedPostsBaseLine
                : entitiesApiRoutes().linkedAnalyzedPostsBaseLine
            }
            customFilters={customLinkedInFilters}
            showDefaultTooltip
            noDayInTimeInterval={!isReport}
            timeIntervalFilter={!isReport}
            hideNames
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_linkedin_analyze_posts_baseline'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        </Grid>
      ),
    },
    {
      id: 'influencers_linkedin_analyze_posts_calendar',
      component: (
        <Grid item lg={4} sm={12}>
          <FullCalendarBlock
            isInfluencerModule={isInfluencerModule}
            compId={'influencers_linkedin_analyze_posts_calendar'}
            id={checkIsTemplate ? influencer_id.linkedin : influencer_id}
            slug={'details/linkedin/calendar'}
            title={
              _t('influencers:posts_calendar') +
              ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
            }
            setActiveTab={setActiveTab}
            setOpenTab={setOpenTab}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_linkedin_analyze_posts_calendar'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
            customFilters={{
              influencer_id: influencer_id,
              linkedin_profile_id,
              is_sample: checkIsTemplate,
            }}
            upToDate={handelAnalyzedCalender}
          />
        </Grid>
      ),
    },
    {
      id: 'influencers_linkedin_analyze_gained_followers',
      component: (
        <Grid item lg={8} sm={12}>
          <BaseLine
            compId={'influencers_linkedin_analyze_gained_followers'}
            withYearTime={isReport}
            baseLineTitle={
              _t('influencers:gained_followers') +
              ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
            }
            slugName={
              isInfluencerModule
                ? influencerApiRoutes().linkedAnalyzedFainedFollowers
                : entitiesApiRoutes().linkedAnalyzedFainedFollowers
            }
            customFilters={customLinkedInFilters}
            showDefaultTooltip
            noDayInTimeInterval={!isReport}
            timeIntervalFilter={!isReport}
            hideNames
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_linkedin_analyze_gained_followers'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        </Grid>
      ),
    },

    {
      id: 'influencers_linkedin_analyze_like',
      component:
        (isInfluencerModule && is_full_grabbed) || isReport ? (
          <IconCard
            hideInput
            title={
              _t('influencers:like') +
              ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
            }
            cardData={{
              icon: <LikeIcon />,
              count: linkedInData?.likes_count,
            }}
            hideDay
            compId={'influencers_linkedin_analyze_like'}
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            customFilters={customLinkedInFilters}
            hideIfNoData={!isReport || isInDownloadCharts}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_linkedin_analyze_like'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_linkedin_analyze_love',
      component:
        (isInfluencerModule && is_full_grabbed) || isReport ? (
          <IconCard
            hideInput
            title={
              _t('influencers:love') +
              ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
            }
            cardData={{
              icon: <BigHeartIcon />,
              count: linkedInData?.loves_count,
            }}
            customFilters={customLinkedInFilters}
            hideDay
            compId={'influencers_linkedin_analyze_love'}
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            hideIfNoData={!isReport || isInDownloadCharts}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_linkedin_analyze_love'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_linkedin_analyze_celebrate',
      component:
        (isInfluencerModule && is_full_grabbed) || isReport ? (
          <IconCard
            customFilters={customLinkedInFilters}
            hideInput
            title={
              _t('influencers:celebrate') +
              ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
            }
            cardData={{
              icon: <CelebrateIcon />,
              count: linkedInData?.celebrates_count,
            }}
            hideDay
            compId={'influencers_linkedin_analyze_celebrate'}
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            hideIfNoData={!isReport || isInDownloadCharts}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_linkedin_analyze_celebrate'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_linkedin_analyze_support',
      component:
        (isInfluencerModule && is_full_grabbed) || isReport ? (
          <IconCard
            hideInput
            title={
              _t('influencers:support') +
              ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
            }
            cardData={{
              icon: <SupportIcon />,
              count: linkedInData?.supports_count,
            }}
            hideDay
            compId={'influencers_linkedin_analyze_support'}
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            customFilters={customLinkedInFilters}
            hideIfNoData={!isReport || isInDownloadCharts}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_linkedin_analyze_support'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_linkedin_analyze_insightful',
      component:
        (isInfluencerModule && is_full_grabbed) || isReport ? (
          <IconCard
            hideInput
            title={
              _t('influencers:insightful') +
              ` ${isReport ? `( ${_t('reports:linkedin')} )` : ''}`
            }
            cardData={{
              icon: <InsightfulIcon />,
              count: linkedInData?.insightful_count,
            }}
            hideDay
            customFilters={customLinkedInFilters}
            compId={'influencers_linkedin_analyze_insightful'}
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            hideIfNoData={!isReport || isInDownloadCharts}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_linkedin_analyze_insightful'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_linkedin_jobs_column',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_linkedin_jobs_column'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={entitiesApiRoutes().LinkedJobsTab}
            activeTab="jobs"
            columns={jobsColumns}
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_linkedin_jobs_column')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_linkedin_jobs_column'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('entities:jobs')} ( ${_t('basic:linkedin')} )`}
              compId={'influencers_linkedin_jobs_column'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_linkedin_alumni_column',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_linkedin_alumni_column'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={entitiesApiRoutes().LinkedAlumniTab}
            activeTab="alumni"
            columns={[
              {
                name: 'influencer_name',
                header: headerCell(_t('entities:alumni')),
                defaultFlex: 1,
                render: (value: any) => {
                  const name = checkTranslated(
                    value?.data?.influencer?.name?.original,
                    value?.data?.influencer?.name?.arabic,
                  );
                  return (
                    <div className="actionsCell">
                      <AvatarCell
                        img={value?.data?.influencer?.image}
                        imageIsClick
                        text={name}
                      />
                    </div>
                  );
                },
              },
              {
                name: 'degree_id',
                header: headerCell(_t('basic:degree')),
                defaultFlex: 1,
                render: (value: any) => (
                  <p className="created_by cursor-pointer">
                    {value?.data?.degree?.label || '_'}
                  </p>
                ),
              },
              {
                name: 'graduation_year',
                header: headerCell(_t('entities:graduation_year')),
                defaultFlex: 1,
                sortable: true,
                render: (value: any) => <p>{value?.data?.graduation_year}</p>,
              },
            ]}
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_linkedin_alumni_column')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_linkedin_alumni_column'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('entities:alumni')} ( ${_t('basic:linkedin')} )`}
              compId={'influencers_linkedin_alumni_column'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_linkedin_employees_column',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_linkedin_employees_column'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={entitiesApiRoutes().LinkedEmployeesTab}
            activeTab="employees"
            columns={[
              {
                name: 'username',
                header: headerCell(_t('entities:employee')),
                defaultFlex: 1,
                render: (value: any) => {
                  const username = value?.data?.username;
                  return (
                    <div className="actionsCell">
                      <AvatarCell
                        img={value?.data?.influencer?.image}
                        imageIsClick
                        text={username}
                      />
                    </div>
                  );
                },
              },
              {
                name: 'title',
                header: headerCell(_t('entities:job_title')),
                defaultFlex: 1,

                render: ({ data }: any) => (
                  <p className="created_by cursor-pointer">
                    {data.title || '-'}
                  </p>
                ),
              },
              {
                name: 'start_date',
                header: headerCell(_t('entities:start_date')),
                defaultFlex: 1,
                sortable: true,
                render: (value: any) => (
                  <p>
                    {value.data.start_date
                      ? dateFormatter(value.data.start_date)
                      : '_'}
                  </p>
                ),
              },
            ]}
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_linkedin_employees_column')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_linkedin_employees_column'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('entities:employees')} ( ${_t('basic:linkedin')} )`}
              compId={'influencers_linkedin_employees_column'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_linkedin_students_column',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_linkedin_students_column'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={entitiesApiRoutes().LinkedStudentsTab}
            activeTab="employees"
            columns={[
              {
                name: 'influencer_name',
                header: headerCell(_t('entities:students')),
                defaultFlex: 1,
                render: (value: any) => {
                  const username = value?.data?.username;
                  return (
                    <div className="actionsCell">
                      <AvatarCell
                        img={value?.data?.influencer?.image}
                        imageIsClick
                        text={username}
                      />
                    </div>
                  );
                },
              },
              {
                name: 'degree_id',
                header: headerCell(_t('basic:degree')),
                defaultFlex: 1,
                render: (value: any) => (
                  <p className="created_by cursor-pointer">
                    {value?.data?.degree?.label || '_'}
                  </p>
                ),
              },
              {
                name: 'graduation_year',
                header: headerCell(_t('entities:graduation_year')),
                defaultFlex: 1,
                sortable: true,
                render: (value: any) => <p>{value?.data?.graduation_year}</p>,
              },
            ]}
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_linkedin_students_column')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_linkedin_students_column'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('entities:students')} ( ${_t('basic:linkedin')} )`}
              compId={'influencers_linkedin_students_column'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
  ];
  const renderChartsList = (chartList: any) =>
    chartList.map((item: any, index: number) =>
      item?.component
        ? React.cloneElement(item.component, { key: item?.id || index })
        : null,
    );

  const renderInstagramCharts: TRenderCharts = [
    {
      id: 'influencers_instagram_analyze_account_type',
      component: instagramData?.account_type ? (
        <IconCard
          compId={'influencers_instagram_analyze_account_type'}
          title={_t('influencers:account_type')}
          cardData={{
            icon: <FollowingIcon />,
            count:
              checkTranslated(
                instagramData?.account_type?.original,
                instagramData?.account_type?.arabic,
              ) || instagramData?.account_type,
          }}
          isUpperCase
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_instagram_analyze_account_type'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ) : (
        <></>
      ),
    },
    {
      id: 'influencers_instagram_analyze_following',
      component: (
        <IconCard
          withFilter
          compId={'influencers_instagram_analyze_following'}
          title={_t('influencers:Following')}
          cardData={{
            icon: <FollowingIcon />,
            countName: 'Following',
          }}
          customFilters={customInstagramFilters}
          hideIfNoData
          slug={
            isInfluencerModule
              ? influencerApiRoutes().instagramAnalyzedFollowing
              : entitiesApiRoutes().instagramAnalyzedFollowing
          }
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_instagram_analyze_following'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_instagram_analyze_similar_accounts',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={_t('influencers:similar_accounts')}
          compId={'influencers_instagram_analyze_similar_accounts'}
          columns={instaSimilarAccounts}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().instagramAnalyzeSimilarAccounts
              : entitiesApiRoutes().instagramAnalyzeSimilarAccounts
          }
          hideIfNoData
          expandAction={() => {
            window.scrollTo(0, 0);
            setActiveTab(1);
            setOpenTab(5);
          }}
          hideFilters
          customFilters={customInstagramFilters}
          notPlatforms
          distributed
          hideToggleView
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_instagram_analyze_similar_accounts'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_instagram_analyze_followers',
      component: (
        <IconCard
          withFilter
          compId={'influencers_instagram_analyze_followers'}
          title={_t('influencers:Followers')}
          cardData={{
            icon: <FollowerIcon />,
            countName: 'Followers',
          }}
          hideIfNoData
          customFilters={customInstagramFilters}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().instagramAnalyzedFollowers
              : entitiesApiRoutes().instagramAnalyzedFollowers
          }
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_instagram_analyze_followers'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
        />
      ),
    },
    {
      id: 'influencers_instagram_analyze_posts',
      component: (
        <IconCard
          withFilter
          compId={'influencers_instagram_analyze_posts'}
          title={_t('influencers:posts')}
          cardData={{
            icon: <TopicsIcon />,
            countName: 'Posts',
          }}
          hideIfNoData
          customFilters={customInstagramFilters}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().instagramAnalyzedPosts
              : entitiesApiRoutes().instagramAnalyzedPosts
          }
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_instagram_analyze_posts'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
        />
      ),
    },
    {
      id: 'influencers_instagram_last_post_per_day',
      component: (
        <IconCard
          compId={'influencers_instagram_last_post_per_day'}
          hideInput
          title={_t('influencers:last_post')}
          cardData={{
            icon: <TopicsIcon />,
          }}
          customFilters={customInstagramFilters}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().instagramLastPost
              : entitiesApiRoutes().instagramLastPost
          }
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_instagram_last_post_per_day'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          useCheckDays
          hideIfNoData
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
        />
      ),
    },
    {
      id: 'influencers_instagram_analyze_posts_calendar',
      component: (
        <Grid item lg={4} sm={12}>
          <FullCalendarBlock
            isInfluencerModule={isInfluencerModule}
            compId={'influencers_instagram_analyze_posts_calendar'}
            id={influencer_id}
            slug={'details/instagram/calendar'}
            title={_t('influencers:posts_calendar')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_instagram_analyze_posts_calendar'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
            setActiveTab={setActiveTab}
            setOpenTab={setOpenTab}
            customFilters={customInstagramFilters}
            upToDate={handelAnalyzedCalender}
          />
        </Grid>
      ),
    },
    {
      id: 'influencers_instagram_analyze_posts_types',
      component: (
        <DonutChart
          donutTitle={_t('influencers:posts_types')}
          limit={5}
          showFilter
          hideInput
          hideIfNoData
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_instagram_analyze_posts_types'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          customFilters={customInstagramFilters}
          title={_t('influencers:posts')}
          compId={'influencers_instagram_analyze_posts_types'}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().instagramAnalyzedPostsTypes
              : entitiesApiRoutes().instagramAnalyzedPostsTypes
          }
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
        />
      ),
    },
    {
      id: 'influencers_instagram_analyze_sentiment',
      component:
        influencerDetails?.status === 'ANALYZED' || isTemplate || isReport ? (
          <DonutChart
            donutTitle={_t('trends:sentiment')}
            limit={5}
            showFilter
            hideInput
            hideIfNoData
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_instagram_analyze_sentiment'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
            customFilters={customInstagramFilters}
            title={_t('influencers:posts')}
            compId={'influencers_instagram_analyze_sentiment'}
            slug={
              isInfluencerModule
                ? influencerApiRoutes().instagramAnalyzedPostSentiment
                : entitiesApiRoutes().instagramAnalyzedPostSentiment
            }
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_instagram_analyze_hashtags',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={_t('influencers:frequent_used_hashtags')}
          compId={'influencers_instagram_analyze_hashtags'}
          columns={instaFrequentHashtags}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().instagramAnalyzedTags
              : entitiesApiRoutes().instagramAnalyzedTags
          }
          hideIfNoData
          expandAction={() => {
            window.scrollTo(0, 0);
            setActiveTab(1);
            setOpenTab(2);
          }}
          hideFilters
          customFilters={customInstagramFilters}
          notPlatforms
          distributed
          hideToggleView
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_instagram_analyze_hashtags'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_instagram_analyze_top_words',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={_t('influencers:top_words')}
          compId={'influencers_instagram_analyze_top_words'}
          columns={instaTopWords}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_instagram_analyze_top_words'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().instagramAnalyzeTopWords
              : entitiesApiRoutes().instagramAnalyzeTopWords
          }
          hideIfNoData
          hideFilters
          customFilters={customInstagramFilters}
          notPlatforms
          distributed
          hideToggleView
        />
      ),
    },
    {
      id: 'influencers_instagram_analyze_most_mentioned',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={_t('influencers:most_mentioned')}
          hideIfNoData
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_instagram_analyze_most_mentioned'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          compId={'influencers_instagram_analyze_most_mentioned'}
          columns={instaTopMentions}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().instagramMentions
              : entitiesApiRoutes().instagramMentions
          }
          expandAction={() => {
            window.scrollTo(0, 0);
            setActiveTab(1);
            setOpenTab(4);
          }}
          hideFilters
          customFilters={customInstagramFilters}
          notPlatforms
          distributed
          hideToggleView
        />
      ),
    },
    {
      id: 'influencers_instagram_analyze_top_tagged',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={_t('influencers:top_tagged')}
          compId={'influencers_instagram_analyze_top_tagged'}
          columns={instaTopTagged}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_instagram_analyze_top_tagged'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().instagramTags
              : entitiesApiRoutes().instagramTags
          }
          hideIfNoData
          expandAction={() => {
            window.scrollTo(0, 0);
            setActiveTab(1);
            setOpenTab(3);
          }}
          hideFilters
          customFilters={customInstagramFilters}
          notPlatforms
          distributed
          hideToggleView
        />
      ),
    },
    {
      id: 'influencers_instagram_analyze_recent_images',
      component: (
        <RecentMedia
          customFilters={{
            ...customInstagramFilters,
            limit: 8,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_instagram_analyze_recent_images'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          slugName={
            isInfluencerModule
              ? influencerApiRoutes().instagramAnalyzeMedia
              : entitiesApiRoutes().instagramAnalyzeMedia
          }
          expandAction={
            isReport
              ? undefined
              : () => {
                  window.scrollTo(0, 0);
                  setActiveTab(1);
                  setOpenTab(0);
                }
          }
          compId={'influencers_instagram_analyze_recent_images'}
          title={_t('influencers:recentimgaes')}
          hideIfNoData
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
        />
      ),
    },
    {
      id: 'influencers_instagram_analyze_comments',
      component: (
        <IconCard
          withFilter
          hideIfNoData
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_instagram_analyze_comments'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          title={_t('influencers:comments')}
          cardData={{
            icon: <InstaComment />,
          }}
          compId={'influencers_instagram_analyze_comments'}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          customFilters={customInstagramFilters}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().instagramAnalyzedComments
              : entitiesApiRoutes().instagramAnalyzedComments
          }
        />
      ),
    },
    {
      id: 'influencers_instagram_analyze_like',
      component: (
        <IconCard
          hideIfNoData
          withFilter
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_instagram_analyze_like'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          title={_t('influencers:like')}
          cardData={{
            icon: <BigHeartIcon />,
          }}
          compId={'influencers_instagram_analyze_like'}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          customFilters={customInstagramFilters}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().instagramAnalyzedLikes
              : entitiesApiRoutes().instagramAnalyzedLikes
          }
        />
      ),
    },
  ];

  const renderTweetCharts: TRenderCharts = [
    {
      id: 'tweets_publish_date',
      component: (
        <IconCard
          withFilter={!isReport}
          hideInput
          title={_t('tweets:publish_date')}
          cardData={{
            icon: <CalenderIcon />,
            count: tweetData?.created_at,
          }}
          hideDay
          compId={'tweets_publish_date'}
          grid={{
            lg: checkIsReport(3, 3),
            sm: 12,
          }}
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'tweets_publish_date'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'tweets_likes',
      component: (
        <IconCard
          hideIfNoData
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'tweets_likes'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          title={_t('tweets:tweet_likes')}
          cardData={{
            icon: <BigHeartIcon />,
            count: tweetData?.likes_count,
          }}
          compId={'tweets_likes'}
          grid={{
            lg: checkIsReport(3, 3),
            sm: 12,
          }}
        />
      ),
    },
    {
      id: 'tweets_replies',
      component: (
        <IconCard
          hideIfNoData
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'tweets_replies'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          title={_t('tweets:tweet_replies')}
          cardData={{
            icon: <TweetRepliesIcon />,
            count: tweetData?.replies_count,
          }}
          compId={'tweets_replies'}
          grid={{
            lg: checkIsReport(3, 3),
            sm: 12,
          }}
        />
      ),
    },
    {
      id: 'tweets_retweets',
      component: (
        <IconCard
          hideIfNoData
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'tweets_retweets'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          title={_t('tweets:tweet_retweets')}
          cardData={{
            icon: <RetweetTweetIcon />,
            count: tweetData?.retweets_count,
          }}
          compId={'tweets_retweets'}
          grid={{
            lg: checkIsReport(3, 3),
            sm: 12,
          }}
        />
      ),
    },
    {
      id: 'tweets_quotes',
      component: (
        <IconCard
          hideIfNoData
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'tweets_quotes'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          title={_t('tweets:tweet_quotes')}
          cardData={{
            icon: <TweetQuotesIcon />,
            count: tweetData?.quotes_count,
          }}
          compId={'tweets_quotes'}
          grid={{
            lg: checkIsReport(3, 3),
            sm: 12,
          }}
        />
      ),
    },
    {
      id: 'tweets_views',
      component: (
        <IconCard
          hideIfNoData
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'tweets_views'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          title={_t('tweets:tweet_views')}
          cardData={{
            icon: <EyeIcon />,
            count: tweetData?.views,
          }}
          compId={'tweets_views'}
          grid={{
            lg: checkIsReport(3, 3),
            sm: 12,
          }}
        />
      ),
    },
    {
      id: 'tweets_bookmarks',
      component: (
        <IconCard
          hideIfNoData
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'tweets_bookmarks'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          title={_t('tweets:tweet_bookmarks')}
          cardData={{
            icon: <BookmarkBigIcon />,
            count: tweetData?.bookmarks_count,
          }}
          compId={'tweets_bookmarks'}
          grid={{
            lg: checkIsReport(3, 3),
            sm: 12,
          }}
        />
      ),
    },
    {
      id: 'tweets_tweet_client',
      component:
        tweetData?.tweet_client?.length > 0 ? (
          <IconCard
            hideIfNoData
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'tweets_tweet_client'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
            title={_t('tweets:tweet_client')}
            cardData={{
              icon: <TweetClient />,
              count: tweetData?.tweet_client,
            }}
            compId={'tweets_tweet_client'}
            grid={{
              lg: checkIsReport(3, 3),
              sm: 12,
            }}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 'tweets_tweet_type',
      component: (
        <IconCard
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'tweets_tweet_type'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          title={_t('tweets:tweet_type')}
          cardData={{
            icon: <TweetType />,
            count: tweetData?.type,
          }}
          compId={'tweets_tweet_type'}
          grid={{
            lg: checkIsReport(3, 3),
            sm: 12,
          }}
        />
      ),
    },
    {
      id: 'tweet_replies_analyze_sentiment',
      component: (
        <>
          <DonutChart
            donutTitle={_t('tweets:replies_sentiment')}
            showFilter
            hideInput
            customFilters={customTweetRepliesSentimentFilters}
            withRefetch
            title={_t('tweets:replies')}
            compId={'tweet_replies_analyze_sentiment'}
            slug={apiRoutes.tweetRepliesSentiment}
            hideIfNoData={!isReport || isInDownloadCharts}
            grid={{
              lg: checkIsReport(3, 3),
              sm: 12,
            }}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'tweet_replies_analyze_sentiment'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        </>
      ),
    },
    {
      id: 'tweet_quotes_analyze_sentiment',
      component: (
        <DonutChart
          donutTitle={_t('tweets:quotes_sentiment')}
          showFilter
          hideInput
          customFilters={customTweetRepliesSentimentFilters}
          title={_t('tweets:quotes')}
          compId={'tweet_quotes_analyze_sentiment'}
          slug={apiRoutes.tweetQuotesSentiment}
          hideIfNoData={!isReport || isInDownloadCharts}
          withRefetch
          grid={{
            lg: checkIsReport(3, 3),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'tweet_quotes_analyze_sentiment'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'tweet_analyze_top_words',
      component: (
        <SecondaryTable
          grid={{
            lg: checkIsReport(3, 3),
            sm: 12,
          }}
          tableCardTitle={_t('influencers:top_words')}
          compId={'tweet_analyze_top_words'}
          columns={topWords}
          moduleName={apiRoutes.tweetTopWords}
          hideFilters
          customFilters={{ ...customTweetRepliesSentimentFilters, limit: 5 }}
          notPlatforms
          distributed
          hideToggleView
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_youtube_analyze_top_words'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'tweets_tweet_hashtags',
      component: (
        <MostFrequentCard
          expandLink={`${path.hashtags.HASHTAG_VIEW_URI}`}
          title={_t('tweets:tweet_hashtags')}
          isReport={isReport}
          isTemplate={isTemplate}
          slug={apiRoutes.tweetFrequentHashtags}
          customFilters={{ ...customTweetRepliesSentimentFilters, limit: 5 }}
          hideIfNoData
          grid={{
            lg: checkIsReport(6, 6),
            sm: 12,
          }}
          compId={'tweets_tweet_hashtags'}
        />
      ),
    },
    {
      id: 'tweet_analyzed_media',
      component: (
        <RecentMedia
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'tweet_analyzed_media'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
          mediaData={tweetData?.attachments}
          compId={'tweet_analyzed_media'}
          title={_t('tweets:tweet_media')}
          hideIfNoData
          grid={{
            lg: checkIsReport(3, 3),
            sm: 12,
          }}
        />
      ),
    },
    {
      id: 'tweets_tweet_influencer_title',
      component: (
        <Grid id="tweets_tweet_influencer_title" item sm={12}>
          <ErrorBoundary>
            <CardTitle
              title={_t('tweets:inf_ent')}
              showBorderBottom
              hideIcon
              maxFontSize
              compId="tweets_tweet_influencer_title"
            />
          </ErrorBoundary>
        </Grid>
      ),
    },
    {
      id: 'tweets_tweet_influencer',
      component: (
        <Grid
          id="tweets_tweet_influencer"
          item
          sm={12}
          className={styles.InfluencerDetails}
        >
          {infDetails.map(({ title, key }) => (
            <div className={styles.InfluencerDetails__Item} key={key}>
              <h5>{title}</h5>
              <span>
                {key == 'joined_at' ? (
                  dateTimeFormatter.date(tweetData?.influencer?.[key])
                ) : key === 'name' ? (
                  <ToolTipComp
                    title={checkHoveringTranslated(
                      tweetData?.influencer?.name?.original,
                      tweetData?.influencer?.name?.arabic,
                    )}
                  >
                    {tweetData?.influencer?.influencer_id !== 0 ? (
                      <Link
                        to={`${
                          tweetData?.influencer?.is_entity
                            ? path.entities.ANALYZED_ENTITIES_DETAILS_URI
                            : tweetData?.influencer?.is_influencer
                              ? path.influencers.ANALYZED_INFLUENCER_DETAILS_URI
                              : path.influencers
                                  .UN_ANALYZED_INFLUENCER_DETAILS_URI
                        }/${tweetData?.influencer?.influencer_id}`}
                        className="cursor-pointer"
                      >
                        {checkTranslated(
                          tweetData?.influencer?.name?.original,
                          tweetData?.influencer?.name?.arabic,
                        ) || tweetData?.username}
                      </Link>
                    ) : (
                      <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          if (tweetData?.influencer?.influencer_id === 0) {
                            openModalToAddinfluencer(tweetData?.username);
                          }
                        }}
                      >
                        {checkTranslated(
                          tweetData?.influencer?.name?.original,
                          tweetData?.influencer?.name?.arabic,
                        ) || tweetData?.username}
                      </span>
                    )}
                  </ToolTipComp>
                ) : key === 'location' ? (
                  tweetData?.influencer?.location?.length ? (
                    tweetData?.influencer?.[key]
                  ) : (
                    <span>-</span>
                  )
                ) : (
                  tweetData?.influencer?.[key]
                )}
              </span>
            </div>
          ))}
        </Grid>
      ),
    },
    {
      id: 'tweets_tweet_title',
      component: (
        <Grid id="tweets_tweet_details" item sm={12}>
          <ErrorBoundary>
            <CardTitle
              title={
                tweetData?.is_quote
                  ? _t('tweets:quote')
                  : tweetData?.is_reply
                    ? _t('tweets:reply')
                    : _t('tweets:tweet')
              }
              showBorderBottom
              hideIcon
              maxFontSize
              compId="tweets_tweet_title"
            />
          </ErrorBoundary>
        </Grid>
      ),
    },
    {
      id: 'tweets_tweet_details',
      component: (
        <Grid
          id="tweets_tweet_details"
          item
          sm={12}
          style={{ marginBottom: '1.5rem', padding: '1rem' }}
          className={styles.InfluencerDetails}
        >
          <div style={{ width: '32%' }}>
            <TwitterTweetCard
              compId="tweetDetails"
              isReport={isReport || isTemplate}
              data={tweetData}
              showConversationFlag
            />
          </div>
        </Grid>
      ),
    },
  ];
  if (isTemplate || addRepliesConvChartToReport) {
    renderTweetCharts.push({
      id: 'tweets_tweet_reply_conversations_column',
      component: (
        <Grid
          id="tweets_tweet_reply_conversations_column"
          item
          sm={12}
          style={{ margin: '1.5rem 0rem', padding: '1rem' }}
          className={styles.InfluencerDetails}
        >
          <div style={{ width: '50%' }}>
            <TwitterTweetCard
              compId="tweets_tweet_reply_conversations_column"
              isReport={isReport || isTemplate}
              is_sample={isTemplate && !isReport}
              data={tweetData}
              showConversationComponent
              showConversationFlag
            />
          </div>
        </Grid>
      ),
    });
  }
  const renderPage = () => {
    //render influencers pages
    if (tab == 'youtube')
      return renderChartsList(
        renderYoutubeCharts.concat(relatedInfluencersColumns),
      );
    if (tab == 'twitter')
      return renderChartsList(
        renderTwitterCharts.concat(relatedInfluencersColumns),
      );
    if (tab == 'author')
      return renderChartsList(
        renderAuthorCharts.concat(relatedInfluencersColumns),
      );
    if (tab == 'linkedin')
      return renderChartsList(
        renderLinkedInCharts.concat(relatedInfluencersColumns),
      );
    if (tab == 'instagram')
      return renderChartsList(
        renderInstagramCharts.concat(relatedInfluencersColumns),
      );
    if (tab === 'tweets') {
      return renderChartsList(
        renderTweetCharts.concat(relatedInfluencersColumns),
      );
    }
    //render report & templates pages
    const renderCharts = renderYoutubeCharts.concat(
      renderTwitterCharts,
      renderAuthorCharts,
      relatedInfluencersColumns,
      renderLinkedInCharts,
      renderInstagramCharts,
      renderTweetCharts,
    );
    if (items) {
      const paragraph = items?.map((item) =>
        extractTitleOrSubTileOrReportNameOrDesc(item),
      );
      const chartsFilter = renderCharts?.map((item: any) =>
        items?.some((i: any) => i?.slug === item?.id)
          ? {
              ...item,
              order: items?.find((comp) => comp.slug === item.id)?.order,
            }
          : null,
      );

      return renderChartsList(
        [...chartsFilter, ...paragraph]
          .filter(Boolean)
          .sort((a, b) => a.order - b.order),
      );
    }

    if (isReport && report) return report?.renderCharts(renderCharts);
  };

  const memoizedRenderPage = useMemo(
    () => renderPage(),

    [
      tab,
      report,
      twitterData,
      youtubeData,
      influencer_id,
      linkedInData,
      instagramData,
      tweetData,
      addRepliesConvChartToReport,
    ],
  );

  return <>{memoizedRenderPage}</>;
};
export default AnalyedInfluencerCharts;
